import { useEffect, useRef, useState } from "react";
import ReactPixel from "react-facebook-pixel";
import TagManager from "react-gtm-module";
import { useMemo } from "react";
import { useLayoutEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Css/animation.css";
import { Navbar, Nav, Offcanvas } from "react-bootstrap";
import {
  icon_black,
  icon_normal,
  home_backdrop,
  car_home,
  dashboard_special_deal,
  group_icon,
  mileage,
  petrol_pump,
  kirkos_logo_white_yellow,
  vector,
  noun_no_image,
} from "../../../assets/images";
import "./styles.css";
import DateTimeComponent from "../../../components/DateTimeComponent";
import moment from "moment";
// import TimePicker from "../../../components/TimePicker/components/TimePicker";
import {
  StarFill,
  PencilSquare,
  Airplane,
  Calendar3,
  CarFront,
  Check2,
  ChevronLeft,
  ChevronRight,
  Clock,
  Funnel,
  GeoAlt,
  Palette,
  Search,
  ShieldCheck,
  Tools,
  ArrowClockwise,
  TagFill,
} from "react-bootstrap-icons";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import { HomeContextType } from "./layout";
import HomePageCarousel from "../../../components/HomePageCarousal";
import FloatingInputLocation from "../../../components/FloatingInputLocation";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axiosInstance from "../../../services/axios.instance";
import { ProductSearch, searchResult } from "../../../types";
import { useMutation } from "@tanstack/react-query";
import { API_URL } from "../../../services/apiConfig";
import CustomerCustomizeYourSearch from "../../../components/CustomerDashBoard/CustomerCustomizeYourSearch";
import QuickSearchModal from "../../../components/QuickSearchModal";
import { COLORS } from "../../../utils/colors";
import { initCapAllWords } from "../../../utils/stringUtil";
import TimePickerComponent from "../../../components/TimePickerComponent";
import MobileTimePickerComponent from "../../../components/TimePickerComponent/MobileTimePicker";
import DateTimePickerComponent from "../../../components/DateTimePickerComponent";
import { toast } from "react-toastify";
import { trackEvent } from "../../../services/events";
import LocationPickerModal from "../../../components/LocationPickerModal";
import SEO from "../../../components/SEO";
import DraggableWhatsAppIcon from "../../../components/CustomerDashBoard/DraggableWhatsAppIcon";
// import { Dayjs } from "dayjs";
// import { initPixel } from "../../../utils/metaAnalytics";
// import { TimePicker as TimePickermui } from "@mui/x-date-pickers/TimePicker";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

interface Location {
  latitude: number | null;
  longitude: number | null;
}

interface FieldErrors {
  pickupDate?: string;
  dropOffDate?: string;
  pickupTime?: string;
  dropOffTime?: string;
  pickupLocation?: string;
  returnLocation?: string;
}

const HomePage = () => {
  const [position, setPosition] = useState(0);

  const handleTrackButtonClick = (buttonName: string) => {
    trackEvent({
      event_name: {
        web: `Kirkos_Home_Page_${buttonName}_Click`,
        app: `Kirkos_Home_Page_${buttonName}_Click_App`,
      },
      event_category: "Button_Click",
      module: "HomePage",
      payload: { button_name: buttonName },
    }).catch(() => { });

    if (process.env.REACT_APP_META_PIXEL_ID) {
      try {
        ReactPixel.track("ButtonClick", {
          content_name: buttonName,
          content_category: "HomePage Buttons",
          content_type: "Button Click",
          value: 0,
          currency: "AED",
        });
      } catch (_) { }
    }
  };

  const [fieldErrors, setFieldErrors] = useState<FieldErrors>({});
  const [serviceConfigs, setServiceConfigs] = useState<any[]>([]);
  const [isServicesLoading, setIsServicesLoading] = useState(true);
  // Ref to the "Update Search" form — used to scroll into view after a search
  const searchFormRef = useRef<HTMLFormElement>(null);
  const resultsShellRef = useRef<HTMLDivElement>(null);

  // const handleAnimate = () => {
  //   // Update the state to trigger the animation
  //   setPosition(position + 1000); // You can adjust the value as needed
  // };

  useEffect(() => {
    // const hasTracked = sessionStorage.getItem("pixel_initialized");
    const fbMetaId = sessionStorage.getItem("fbclid");
    const searchParams = new URLSearchParams(window.location.search);
    const urlUtmParams: any = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach(key => {
      const val = searchParams.get(key);
      if (val) urlUtmParams[key] = val;
    });

    const storedUtmParams = JSON.parse(sessionStorage.getItem("utm_params") || "{}");
    const utmParams = { ...storedUtmParams, ...urlUtmParams };

    // Persist combined params to sessionStorage if new ones found in URL
    if (Object.keys(urlUtmParams).length > 0) {
      sessionStorage.setItem("utm_params", JSON.stringify(utmParams));
    }

    const campaignType = utmParams.utm_campaign || null;
    console.log("UTM Parameters Detected:", utmParams);
    console.log("Campaign Type:", campaignType);

    // if (!hasTracked) {
    console.log("Initializing Meta Pixel and tracking ViewContent...");
    ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID!);
    ReactPixel.track("ViewContent", {
      content_type: "VIEW_CONTENT",
      content_name: "Kirkos Landing Page",
    });

    // Track Page Load Event
    console.log("Triggering Kirkos_Home_Page_Load event...");
    trackEvent({
      event_name: {
        web: "Kirkos_Home_Page_Load",
        app: "Kirkos_Home_Page_Load_App",
      },
      event_category: "Page_View",
      module: "HomePage",
      payload: {
        campaign_name: campaignType || "",
        source: "website"
      },
    }).then(() => {
      console.log("Kirkos_Home_Page_Load event tracked successfully.");
    }).catch((err) => {
      console.error("Error tracking homepage load event:", err);
    });

    const createCRMLead = async () => {
      try {
        const ipResponse = await fetch("https://api.ipify.org?format=json");
        const ipData = await ipResponse.json();
        const response = await axiosInstance.post(API_URL.CRM_LEADS, {
          full_name: "",
          phone_number: "",
          email: "",
          source: "website",
          campaign_name: campaignType || "",
          ip_address: ipData?.ip,
          meta_click_id: fbMetaId,
        });
      } catch (error) {
        console.error("Error creating CRM lead:", error);
      }
    };
    createCRMLead();
    ReactPixel.track("ViewContent", {
      content_name: "Homepage",
    });
    sessionStorage.setItem("pixel_initialized", "true");
    // }
  }, []);

  // ── Scroll Depth Tracking ─────────────────────────────────────────────────
  useEffect(() => {
    const trackedDepths = new Set<number>();
    const THRESHOLDS = [25, 50, 75, 100];

    // Compute scroll percentage from whichever source has scrolled.
    // We check window, the layout container, and document — whichever
    // reports a non-zero scroll wins.
    const getScrollPct = (): number => {
      const sources = [
        // 1. Window / documentElement
        () => {
          const scrolled = window.scrollY || document.documentElement.scrollTop || 0;
          const total = Math.max(
            document.documentElement.scrollHeight,
            document.body.scrollHeight
          ) - window.innerHeight;
          return total > 0 ? scrolled / total : 0;
        },
        // 2. The named layout container (#searchFormSection / .div-home)
        () => {
          const el = document.getElementById("searchFormSection");
          if (!el) return 0;
          const total = el.scrollHeight - el.clientHeight;
          return total > 0 ? el.scrollTop / total : 0;
        },
        // 3. The inner .landing-shell card
        () => {
          const el = document.querySelector(".landing-shell") as HTMLElement | null;
          if (!el) return 0;
          const total = el.scrollHeight - el.clientHeight;
          return total > 0 ? el.scrollTop / total : 0;
        },
      ];

      return Math.min(
        Math.round(Math.max(...sources.map(fn => { try { return fn(); } catch { return 0; } })) * 100),
        100
      );
    };

    const checkDepth = () => {
      const pct = getScrollPct();
      if (pct <= 0) return;

      THRESHOLDS.forEach((depth) => {
        if (pct >= depth && !trackedDepths.has(depth)) {
          trackedDepths.add(depth);
          console.debug(`[Analytics] Scroll depth ${depth}% reached`);

          trackEvent({
            event_name: `Kirkos_Home_Scroll_Depth_${depth}`,
            event_category: "User_Engagement",
            module: "HomePage",
            payload: { depth_percentage: depth },
          }).catch(() => { });

          if (process.env.REACT_APP_META_PIXEL_ID) {
            try {
              ReactPixel.track("ScrollDepth", {
                content_category: "HomePage",
                depth_percentage: depth,
              });
            } catch (_) { }
          }
        }
      });
    };

    // Check once shortly after mount so already-scrolled views are captured
    const initTimer = setTimeout(checkDepth, 600);

    // Attach to every possible scrolling surface
    const layoutEl = document.getElementById("searchFormSection");
    const shellEl = document.querySelector(".landing-shell");

    window.addEventListener("scroll", checkDepth, { passive: true });
    document.addEventListener("scroll", checkDepth, { passive: true });
    layoutEl?.addEventListener("scroll", checkDepth, { passive: true });
    shellEl?.addEventListener("scroll", checkDepth, { passive: true });
    window.addEventListener("resize", checkDepth, { passive: true });

    return () => {
      clearTimeout(initTimer);
      window.removeEventListener("scroll", checkDepth);
      document.removeEventListener("scroll", checkDepth);
      layoutEl?.removeEventListener("scroll", checkDepth);
      shellEl?.removeEventListener("scroll", checkDepth);
      window.removeEventListener("resize", checkDepth);
    };
  }, []);

  // ── Frontend Error Tracking ───────────────────────────────────────────────
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      trackEvent({
        event_name: "Kirkos_Home_Frontend_Error",
        event_category: "Error",
        module: "HomePage",
        payload: {
          message: event.message,
          filename: event.filename,
          lineno: event.lineno,
          colno: event.colno,
          stack: event.error?.stack?.substring(0, 500) ?? "",
        },
      }).catch(() => { });
      if (process.env.REACT_APP_META_PIXEL_ID) {
        try { ReactPixel.track("FrontendError", { message: event.message }); } catch (_) { }
      }
    };

    const handleRejection = (event: PromiseRejectionEvent) => {
      trackEvent({
        event_name: "Kirkos_Home_Unhandled_Promise_Rejection",
        event_category: "Error",
        module: "HomePage",
        payload: { reason: String(event.reason).substring(0, 300) },
      }).catch(() => { });
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleRejection);
    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener("unhandledrejection", handleRejection);
    };
  }, []);

  // ── Time-on-Page Heartbeat ────────────────────────────────────────────────
  useEffect(() => {
    const milestones = [30, 60, 120]; // seconds
    const timers: ReturnType<typeof setTimeout>[] = milestones.map((sec) =>
      setTimeout(() => {
        trackEvent({
          event_name: `Kirkos_Home_Time_On_Page_${sec}s`,
          event_category: "User_Engagement",
          module: "HomePage",
          payload: { seconds: sec },
        }).catch(() => { });
        if (process.env.REACT_APP_META_PIXEL_ID) {
          try { ReactPixel.track("TimeOnPage", { seconds: sec, page: "HomePage" }); } catch (_) { }
        }
      }, sec * 1000)
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  // Fetch Service Configs from API
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axiosInstance.get(API_URL.SERVICE_CONFIGS);
        if (response.data && Array.isArray(response.data)) {
          setServiceConfigs(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch services:", error);
      } finally {
        setIsServicesLoading(false);
      }
    };
    fetchServices();
  }, []);

  const ICON_MAP: Record<string, any> = {
    CarFront,
    Airplane,
    Tools,
    ShieldCheck,
    Palette,
  };

  useEffect(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("refresh_token");
    localStorage.removeItem("carInformation");
    localStorage.removeItem("productImages");
    localStorage.removeItem("carInsuranceInformation");
  }, []);
  //-------------------------------------------------------------------------------------------------------------------
  const [isRotating, setIsRotating] = useState(false);

  // Persistence: Initialize states from sessionStorage if available
  const getSavedData = () => {
    const saved = sessionStorage.getItem("kirkos_search_data");
    return saved ? JSON.parse(saved) : null;
  };

  const savedData = getSavedData();

  // Flag to track if the location has been determined (either by geolocation or manual selection)
  const [locationResolved, setLocationResolved] = useState<boolean>(
    !!savedData?.locationResolved
  );

  const [pickupLocation, setPickupLocation] = useState<Location>(
    savedData?.pickupLocation || { latitude: 25.0786415, longitude: 55.1352524 }
  );

  const [returnLocation, setReturnLocation] = useState<Location>(
    savedData?.returnLocation || { latitude: 25.0786415, longitude: 55.1352524 }
  );

  const [pickupDate, setPickupDate] = useState<any>(() => {
    if (savedData?.pickupDate) return new Date(savedData.pickupDate);
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  });

  const [dropOffDate, setDropOffDate] = useState<any>(() => {
    if (savedData?.dropOffDate) return new Date(savedData.dropOffDate);
    const d = new Date();
    d.setDate(d.getDate() + 8); // default to one week after today
    return d;
  });

  const [selectedTime, setSelectedTime] = useState(savedData?.selectedTime || "10:00");
  const [selectedDropTime, setSelectedDropTime] = useState(savedData?.selectedDropTime || "10:00");

  const [searchValues, setSearchValues] = useState<any>(
    savedData?.searchValues || {
      pickup: "Dubai Marina, Dubai, United Arab Emirates",
      return: "Dubai Marina, Dubai, United Arab Emirates",
    }
  );

  // Save search state to sessionStorage whenever it changes
  useEffect(() => {
    const kirkosSearchData = {
      searchValues,
      pickupLocation,
      returnLocation,
      pickupDate: pickupDate instanceof Date ? pickupDate.toISOString() : pickupDate,
      dropOffDate: dropOffDate instanceof Date ? dropOffDate.toISOString() : dropOffDate,
      selectedTime,
      selectedDropTime,
      locationResolved
    };
    sessionStorage.setItem("kirkos_search_data", JSON.stringify(kirkosSearchData));
  }, [searchValues, pickupLocation, returnLocation, pickupDate, dropOffDate, selectedTime, selectedDropTime, locationResolved]);


  const [searchCars, SetSearchCars] = useState<any>([]);
  const [searchMessage, setSearchMessage] = useState<string | null>(null);
  const [isSameDate, setIsSameDate] = useState<boolean>(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [brandSearchQuery, setBrandSearchQuery] = useState("");
  const [selectedCarTypes, setSelectedCarTypes] = useState<string[]>([]);
  const [selectedBrands, setSelectedBrands] = useState<string[]>([]);
  const [selectedFuelTypes, setSelectedFuelTypes] = useState<string[]>([]);
  const [selectedTransmissions, setSelectedTransmissions] = useState<string[]>([]);
  const [isUnlimitedMileage, setIsUnlimitedMileage] = useState(false);
  const [priceRange, setPriceRange] = useState({ min: 0, max: 0 });
  const [weeklyPriceRange, setWeeklyPriceRange] = useState({ min: 0, max: 0 });
  const [monthlyPriceRange, setMonthlyPriceRange] = useState({ min: 0, max: 0 });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;
  const [pickupTimeError, setPickupTimeError] = useState<string>("");
  const [dropOffTimeError, setDropOffTimeError] = useState<string>("");
  const [activeFilter, setActiveFilter] = useState<string | null>(null);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);
  const [customizeResult, setCustomizeResult] = useState<any>(null);

  // Try to set user's current location as default pickup on mount.
  // Falls back silently to the Dubai Marina default if permission denied or lookup fails.
  useEffect(() => {
    // Only run geolocation if the location hasn't been resolved yet in this session
    if (locationResolved) return;
    if (!navigator.geolocation) return;

    const LOCATIONIQ_TOKEN = process.env.REACT_APP_LOCATIONIQ_TOKEN;

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        try {
          const response = await fetch(
            `https://us1.locationiq.com/v1/reverse?key=${LOCATIONIQ_TOKEN}&lat=${latitude}&lon=${longitude}&format=json`
          );
          const data = await response.json();
          const label: string | undefined = data?.display_name;

          if (label) {
            setSearchValues({ pickup: label, return: label });
            setPickupLocation({ latitude, longitude });
            setReturnLocation({ latitude, longitude });
            setLocationResolved(true);
          }
          // If no label returned, Dubai Marina default stays intact
        } catch {
          // Reverse-geocode failed — silently keep the default location
        }
      },
      () => {
        // Permission denied or unavailable — silently keep the default location
      },
      { timeout: 8000, maximumAge: 60000 }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [showPickupMapModal, setShowPickupMapModal] = useState(false);
  const { searchResultHeading, setSearchResultHeading } = useOutletContext<HomeContextType>();
  const [showReturnMapModal, setShowReturnMapModal] = useState(false);
  const [returnToSameLocation, setReturnToSameLocation] = useState(true);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [selectedBookingItem, setSelectedBookingItem] = useState<any>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (activeFilter) {
        const target = event.target as HTMLElement;
        if (!target.closest(".home-results-combo")) {
          setActiveFilter(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeFilter]);


  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const webViewKeywords = ["wv", "version/"];
    const isAndroidWebView =
      /android/.test(userAgent) &&
      webViewKeywords.some((kw) => userAgent.includes(kw));
    const isIosWebView =
      /iphone | ipod | ipad /.test(userAgent) &&
      (userAgent.includes("safari") === false ||
        /crios | fxios/.test(userAgent));

    setIsMobileView(isAndroidWebView || isIosWebView);
    setIsMobileView(isAndroidWebView || isIosWebView);
  }, []);

  useEffect(() => {
    if (!pickupDate) {
      setPickupTimeError("");
      return;
    }

    const timeToValidate = selectedTime || "09:00";

    setFieldErrors(prev => ({ ...prev, pickupTime: undefined }));
    const selectedDate = new Date(pickupDate);
    const today = new Date();
    const currentHour = today.getHours();
    const currentMinutes = today.getMinutes();
    const minimumTime = new Date(today.getTime() + 2 * 60 * 60 * 1000);
    const [hours, minutes] = timeToValidate.split(":").map(Number);
    const isToday =
      selectedDate.getDate() === today.getDate() &&
      selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getFullYear() === today.getFullYear();

    const isNoServiceToday = isToday && (currentHour * 60 + currentMinutes + 120 >= 22 * 60);

    if (isNoServiceToday) {
      setPickupTimeError("* No service available for today. Please select tomorrow's date");
    } else if (isToday) {
      // Explicit "Today" Time Validation Logic
      const currentTotalMinutes = currentHour * 60 + currentMinutes;
      const selectedTotalMinutes = hours * 60 + minutes;
      const minimumTotalMinutes = currentTotalMinutes + 120;

      if (minimumTotalMinutes >= 22 * 60) {
        setPickupTimeError("* No service available for today.");
      } else if (
        selectedTotalMinutes < minimumTotalMinutes ||
        !((hours < 22) || (hours === 22 && minutes === 0))
      ) {
        const minHour = minimumTime.getHours();
        const minMinute = minimumTime.getMinutes();
        setPickupTimeError(
          `* Today services are available between ${String(minHour).padStart(2, "0")}:${String(minMinute).padStart(2, "0")} to 22:00`
        );
      } else {
        setPickupTimeError("");
      }
    } else {
      // Future Date - Standard Validation
      if (!((hours === 22 && minutes === 0) || (hours >= 9 && hours < 22))) {
        setPickupTimeError("* Services available between 09:00 to 22:00");
      } else {
        setPickupTimeError("");
      }
    }

  }, [pickupDate, selectedTime]);

  //   setSelectedDropTime(newTime);
  // };

  // const handleTimeChange = (time: any) => {
  //   setSelectedTime(time);
  // };
  const validateTime = (time: string): boolean => {
    const [hours, minutes] = time.split(':').map(Number);
    return (hours === 22 && minutes === 0) || (hours >= 9 && hours < 22);
  };


  const validateTodayTime = (time: string): boolean => {
    const [hours, minutes] = time.split(':').map(Number);
    const selectedDate = new Date(pickupDate);
    const today = new Date();

    // Normalize dates to compare just the day
    const isToday =
      selectedDate.getDate() === today.getDate() &&
      selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getFullYear() === today.getFullYear();

    if (isToday) {
      const currentHour = today.getHours();
      const currentMinutes = today.getMinutes();
      const selectedTotalMinutes = hours * 60 + minutes;
      const currentTotalMinutes = currentHour * 60 + currentMinutes;
      const minimumTotalMinutes = currentTotalMinutes + 240;

      if (minimumTotalMinutes >= 22 * 60) {
        return false;
      }
      return selectedTotalMinutes >= minimumTotalMinutes &&
        ((hours < 22) || (hours === 22 && minutes === 0));
    }

    return (hours === 22 && minutes === 0) || (hours >= 9 && hours < 22);
  };

  useEffect(() => {
    if (!pickupDate || !dropOffDate || !selectedTime || !selectedDropTime) {
      setIsSameDate(false);
      return;
    }

    try {
      const pDate = new Date(pickupDate);
      const dDate = new Date(dropOffDate);

      if (Number.isNaN(pDate.getTime()) || Number.isNaN(dDate.getTime())) {
        setIsSameDate(false);
        return;
      }

      const pDateStr = pDate.toISOString().split("T")[0];
      const dDateStr = dDate.toISOString().split("T")[0];

      if (pDateStr > dDateStr) {
        setIsSameDate(true);
      } else if (pDateStr === dDateStr) {
        const [pH, pM] = selectedTime.split(":").map(Number);
        const [dH, dM] = selectedDropTime.split(":").map(Number);
        const pTotal = pH * 60 + pM;
        const dTotal = dH * 60 + dM;

        // If drop-off time is later than pickup time on same day, it's valid (isSameDate = false)
        setIsSameDate(dTotal <= pTotal);
      } else {
        setIsSameDate(false);
      }
    } catch (e) {
      setIsSameDate(false);
    }
  }, [pickupDate, dropOffDate, selectedTime, selectedDropTime]);

  // Auto-load products on page mount
  useEffect(() => {
    handleSubmit(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDropOffTimeChange = (newTime: string | null) => {
    if (newTime) {
      setSelectedDropTime(newTime);
      setFieldErrors(prev => ({ ...prev, dropOffTime: undefined }));
      if (!validateTime(newTime)) {
        setDropOffTimeError("* Services available between 09:00 to 22:00");
      } else {
        setDropOffTimeError("");
      }
      trackEvent({ event_name: "Kirkos_Home_DropOff_Time_Selected", event_category: "Search_Interaction", module: "HomePage", payload: { dropoff_time: newTime } }).catch(() => { });
      if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("DropOffTimeSelected", { dropoff_time: newTime }); } catch (_) { } }
    } else {
      setDropOffTimeError("");
    }
  };

  const handleTimeChange = (time: string | null) => {
    if (time) {
      setSelectedTime(time);
      setFieldErrors(prev => ({ ...prev, pickupTime: undefined }));
      trackEvent({ event_name: "Kirkos_Home_Pickup_Time_Selected", event_category: "Search_Interaction", module: "HomePage", payload: { pickup_time: time } }).catch(() => { });
      if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("PickupTimeSelected", { pickup_time: time }); } catch (_) { } }
    } else {
      console.log("Selected Time: None");
      setPickupTimeError("");
    }
  };
  const isMobile =
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ||
    window.innerWidth <= 768;

  const handleCustomizeResult = (customResult: any) => {
    setCustomizeResult(customResult);
    if (customResult.priceRange) setPriceRange(customResult.priceRange);
    if (customResult.weeklyPriceRange) setWeeklyPriceRange(customResult.weeklyPriceRange);
    if (customResult.monthlyPriceRange) setMonthlyPriceRange(customResult.monthlyPriceRange);
    if (customResult.selectedCarTypes) setSelectedCarTypes(customResult.selectedCarTypes);
    if (customResult.selectedBrands) setSelectedBrands(customResult.selectedBrands);
    if (customResult.selectedFuelTypes) setSelectedFuelTypes(customResult.selectedFuelTypes);
    if (customResult.selectedTransmissions) setSelectedTransmissions(customResult.selectedTransmissions);
    if (customResult.isUnlimitedMileage !== undefined) setIsUnlimitedMileage(customResult.isUnlimitedMileage);
    trackEvent({ event_name: "Kirkos_Home_Advanced_Filters_Applied", event_category: "Filter_Interaction", module: "HomePage", payload: { car_types: customResult.selectedCarTypes, brands: customResult.selectedBrands, unlimited_mileage: customResult.isUnlimitedMileage } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("CustomizeSearchApplied", { car_types: customResult.selectedCarTypes?.join(","), brands: customResult.selectedBrands?.join(",") }); } catch (_) { } }
  };

  const handleCustomization = () => {
    setShowCreateProduct(true);
    trackEvent({ event_name: "Kirkos_Home_Advanced_Filters_Opened", event_category: "Filter_Interaction", module: "HomePage", payload: {} }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("CustomizeSearchOpened", {}); } catch (_) { } }
  };

  const toggleFilterValue = (value: string, setter: React.Dispatch<React.SetStateAction<string[]>>) => {
    const normalizedValue = String(value || "").trim().toUpperCase();
    setter((prev) => {
      const isRemoving = prev.includes(normalizedValue);
      trackEvent({ event_name: isRemoving ? "Kirkos_Home_Filter_Removed" : "Kirkos_Home_Filter_Added", event_category: "Filter_Interaction", module: "HomePage", payload: { filter_value: normalizedValue } }).catch(() => { });
      if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track(isRemoving ? "FilterRemoved" : "FilterAdded", { filter_value: normalizedValue }); } catch (_) { } }
      return isRemoving ? prev.filter((item: string) => item !== normalizedValue) : [...prev, normalizedValue];
    });
    setCurrentPage(1);
  };

  const handleDailyPriceChange = (min: number, max: number) => {
    trackEvent({ event_name: "Kirkos_Home_Daily_Price_Filter", event_category: "Filter_Interaction", module: "HomePage", payload: { min, max } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("DailyPriceFilter", { min, max }); } catch (_) { } }
    setPriceRange({ min, max });
    setWeeklyPriceRange({
      min: filterCatalog.minWeeklyPrice,
      max: filterCatalog.maxWeeklyPrice,
    });
    setMonthlyPriceRange({
      min: filterCatalog.minMonthlyPrice,
      max: filterCatalog.maxMonthlyPrice,
    });
    setCurrentPage(1);
  };

  const handleWeeklyPriceChange = (min: number, max: number) => {
    trackEvent({ event_name: "Kirkos_Home_Weekly_Price_Filter", event_category: "Filter_Interaction", module: "HomePage", payload: { min, max } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("WeeklyPriceFilter", { min, max }); } catch (_) { } }
    setWeeklyPriceRange({ min, max });
    setPriceRange({
      min: filterCatalog.minPrice,
      max: filterCatalog.maxPrice,
    });
    setMonthlyPriceRange({
      min: filterCatalog.minMonthlyPrice,
      max: filterCatalog.maxMonthlyPrice,
    });
    setCurrentPage(1);
  };

  const handleMonthlyPriceChange = (min: number, max: number) => {
    trackEvent({ event_name: "Kirkos_Home_Monthly_Price_Filter", event_category: "Filter_Interaction", module: "HomePage", payload: { min, max } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("MonthlyPriceFilter", { min, max }); } catch (_) { } }
    setMonthlyPriceRange({ min, max });
    setPriceRange({
      min: filterCatalog.minPrice,
      max: filterCatalog.maxPrice,
    });
    setWeeklyPriceRange({
      min: filterCatalog.minWeeklyPrice,
      max: filterCatalog.maxWeeklyPrice,
    });
    setCurrentPage(1);
  };

  const resetFilters = () => {
    handleTrackButtonClick("Reset_Filters");
    setIsRotating(true);
    setTimeout(() => setIsRotating(false), 800);

    setPriceRange({
      min: filterCatalog.minPrice,
      max: filterCatalog.maxPrice,
    });
    setWeeklyPriceRange({
      min: filterCatalog.minWeeklyPrice,
      max: filterCatalog.maxWeeklyPrice,
    });
    setMonthlyPriceRange({
      min: filterCatalog.minMonthlyPrice,
      max: filterCatalog.maxMonthlyPrice,
    });
    setSelectedCarTypes([]);
    setSelectedBrands([]);
    setSelectedFuelTypes([]);
    setSelectedTransmissions([]);
    setIsUnlimitedMileage(false);
    setBrandSearchQuery("");
    setCurrentPage(1);
  };

  const handleClearSearch = () => {
    handleTrackButtonClick("Clear_All");
    setIsRotating(true);
    setTimeout(() => setIsRotating(false), 800);

    setSearchValues({
      pickup: "",
      return: "",
    });
    setPickupLocation({ latitude: null, longitude: null });
    setReturnLocation({ latitude: null, longitude: null });
    setPickupDate("");
    setDropOffDate("");
    setSelectedTime("");
    setSelectedDropTime("");
    setCarName("");
    setFieldErrors({});
    setPickupTimeError("");
    setDropOffTimeError("");
    setIsSameDate(false);
    setSearchResultHeading(false);
    SetSearchCars([]);
    // Remove from session storage to prevent auto-fill on refresh
    sessionStorage.removeItem("kirkos_search_data");
  };

  const [pickupSuggestions, setPickupSuggestions] = useState<
    { name: string; latitude: number; longitude: number }[]
  >([]);
  const [returnSuggestions, setReturnSuggestions] = useState<
    { name: string; latitude: number; longitude: number }[]
  >([]);

  const fetchCoordinates = async (searchQuery: string) => {
    try {
      const response = await axiosInstance.get(
        `https:///nominatim.kirkos.ae/search.php?q=${searchQuery}&format=geocodejson`
      );
      if (response.data && response.data.features.length > 0) {
        const suggestions = response.data.features.map((feature: any) => ({
          name: feature.properties.geocoding.label,
          latitude: feature.geometry.coordinates[1],
          longitude: feature.geometry.coordinates[0],
        }));
        return suggestions;
      }
      return [];
    } catch (error) {
      return [];
    }
  };

  const handlePickupLocationChange = async (value: string) => {
    setSearchValues((prevValues: any) => ({ ...prevValues, pickup: value }));
    try {
      const suggestions = await fetchCoordinates(value);
      if (suggestions.length > 0) {
        const { latitude, longitude } = suggestions[0];
        setPickupSuggestions(suggestions);
        setPickupLocation({ latitude, longitude });
      } else {
        setPickupSuggestions([]);
        setPickupLocation({ latitude: null, longitude: null });
      }
    } catch (error) {
      console.error("Error fetching pickup location suggestions:", error);
    }
  };

  const handleReturnLocationChange = async (value: string) => {
    setSearchValues((prevValues: any) => ({ ...prevValues, return: value }));
    try {
      const suggestions = await fetchCoordinates(value);
      if (suggestions.length > 0) {
        const { latitude, longitude } = suggestions[0];
        setReturnSuggestions(suggestions);
        setReturnLocation({ latitude, longitude });
      } else {
        setReturnSuggestions([]);
        setReturnLocation({ latitude: null, longitude: null });
      }
    } catch (error) {
      console.error("Error fetching return location suggestions:", error);
    }
  };

  const handlePickupLocationSelection = (selectedLocation: {
    name?: string;
    latitude: any;
    longitude: any;
  }) => {
    trackEvent({ event_name: "Kirkos_Home_Pickup_Location_Selected", event_category: "Search_Interaction", module: "HomePage", payload: { location: selectedLocation.name, lat: selectedLocation.latitude, lng: selectedLocation.longitude } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("PickupLocationSelected", { location: selectedLocation.name }); } catch (_) { } }
    setLocationResolved(true);
    setSearchValues((prevValues: any) => ({
      ...prevValues,
      pickup: selectedLocation.name,
    }));
    setPickupLocation({
      latitude: selectedLocation.latitude,
      longitude: selectedLocation.longitude,
    });
    setFieldErrors(prev => ({ ...prev, pickupLocation: undefined }));

    setPickupSuggestions([]);

    // If return to same location is ON, sync return location
    if (returnToSameLocation) {
      setSearchValues((prevValues: any) => ({
        ...prevValues,
        return: selectedLocation.name,
      }));
      setReturnLocation({
        latitude: selectedLocation.latitude,
        longitude: selectedLocation.longitude,
      });
      setFieldErrors(prev => ({ ...prev, returnLocation: undefined }));
    }
  };

  const handleReturnLocationSelection = (selectedLocation: {
    name?: string;
    latitude: any;
    longitude: any;
  }) => {
    trackEvent({ event_name: "Kirkos_Home_DropOff_Location_Selected", event_category: "Search_Interaction", module: "HomePage", payload: { location: selectedLocation.name, lat: selectedLocation.latitude, lng: selectedLocation.longitude } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("DropOffLocationSelected", { location: selectedLocation.name }); } catch (_) { } }
    setLocationResolved(true);
    setSearchValues((prevValues: any) => ({
      ...prevValues,
      return: selectedLocation.name,
    }));
    setReturnLocation({
      latitude: selectedLocation.latitude,
      longitude: selectedLocation.longitude,
    });
    setFieldErrors(prev => ({ ...prev, returnLocation: undefined }));
    setReturnSuggestions([]);
  };

  const handleSameAsPickup = () => {
    setSearchValues((prevValues: any) => ({
      ...prevValues,
      return: searchValues.pickup,
    }));
    setReturnLocation(pickupLocation);
    setFieldErrors((prev) => ({ ...prev, returnLocation: undefined }));
    setReturnSuggestions([]);
  };

  const handlePickupMapSelect = (location: { name: string; latitude: number; longitude: number }) => {
    trackEvent({ event_name: "Kirkos_Home_Pickup_Map_Location_Selected", event_category: "Search_Interaction", module: "HomePage", payload: { location: location.name } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("PickupMapSelected", { location: location.name }); } catch (_) { } }
    setLocationResolved(true);
    setSearchValues((prevValues: any) => ({
      ...prevValues,
      pickup: location.name,
    }));
    setPickupLocation({
      latitude: location.latitude,
      longitude: location.longitude,
    });
    setFieldErrors(prev => ({ ...prev, pickupLocation: undefined }));
    setPickupSuggestions([]);

    // If return to same location is ON, sync return location
    if (returnToSameLocation) {
      setSearchValues((prevValues: any) => ({
        ...prevValues,
        return: location.name,
      }));
      setReturnLocation({
        latitude: location.latitude,
        longitude: location.longitude,
      });
      setFieldErrors(prev => ({ ...prev, returnLocation: undefined }));
    }
  };

  const handleReturnMapSelect = (location: { name: string; latitude: number; longitude: number }) => {
    trackEvent({ event_name: "Kirkos_Home_DropOff_Map_Location_Selected", event_category: "Search_Interaction", module: "HomePage", payload: { location: location.name } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("DropOffMapSelected", { location: location.name }); } catch (_) { } }
    setLocationResolved(true);
    setSearchValues((prevValues: any) => ({
      ...prevValues,
      return: location.name,
    }));
    setReturnLocation({
      latitude: location.latitude,
      longitude: location.longitude,
    });
    setFieldErrors(prev => ({ ...prev, returnLocation: undefined }));
    setReturnSuggestions([]);
  };

  const handleToggleReturnToSameLocation = () => {
    const newValue = !returnToSameLocation;
    trackEvent({ event_name: "Kirkos_Home_Return_Same_Location_Toggle", event_category: "Search_Interaction", module: "HomePage", payload: { enabled: newValue } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("ReturnSameLocationToggle", { enabled: newValue }); } catch (_) { } }
    setReturnToSameLocation(newValue);

    // If turning ON, sync return location with pickup location
    if (newValue && searchValues.pickup) {
      setSearchValues((prevValues: any) => ({
        ...prevValues,
        return: searchValues.pickup,
      }));
      setReturnLocation(pickupLocation);
      setFieldErrors((prev) => ({ ...prev, returnLocation: undefined }));
    }
    // If turning OFF, clear return location
    else if (!newValue) {
      setSearchValues((prevValues: any) => ({
        ...prevValues,
        return: '',
      }));
      setReturnLocation({ latitude: null, longitude: null });
    }
  };
  const handlePickupDateChange = (date: string | null) => {
    if (!date) {
      setPickupDate("");
      return;
    }
    trackEvent({ event_name: "Kirkos_Home_Pickup_Date_Selected", event_category: "Search_Interaction", module: "HomePage", payload: { pickup_date: date } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("PickupDateSelected", { pickup_date: date }); } catch (_) { } }
    setPickupDate(date);
    setFieldErrors(prev => ({ ...prev, pickupDate: undefined }));
  };

  const handleDropOffDateChange = (date: string | null) => {
    if (!date) {
      setDropOffDate("");
      return;
    }
    trackEvent({ event_name: "Kirkos_Home_DropOff_Date_Selected", event_category: "Search_Interaction", module: "HomePage", payload: { dropoff_date: date } }).catch(() => { });
    if (process.env.REACT_APP_META_PIXEL_ID) { try { ReactPixel.track("DropOffDateSelected", { dropoff_date: date }); } catch (_) { } }
    setDropOffDate(date);

    const selectedDate = new Date(date);

    if (pickupDate) {
      const maxAllowed = new Date(pickupDate);
      maxAllowed.setDate(maxAllowed.getDate() + 30);

      if (selectedDate > maxAllowed) {
        setFieldErrors(prev => ({
          ...prev,
          dropOffDate: "Drop-off date cannot be more than 30 days from the pickup date",
        }));
      } else {
        setFieldErrors(prev => ({ ...prev, dropOffDate: undefined }));
      }
    } else {
      setFieldErrors(prev => ({ ...prev, dropOffDate: undefined }));
    }
  };

  const { control } = useForm({
    mode: "onChange",
  });

  const validateSearchForm = () => {
    const errors: FieldErrors = {};

    if (!pickupDate) {
      errors.pickupDate = "Pick up date is required";
    }
    if (!dropOffDate) {
      errors.dropOffDate = "Drop off date is required";
    }
    if (!selectedTime) {
      errors.pickupTime = "Pick up time is required";
    }
    if (!selectedDropTime) {
      errors.dropOffTime = "Drop off time is required";
    }
    if (!pickupLocation.latitude || !pickupLocation.longitude) {
      errors.pickupLocation = "Pick up location is required";
    }
    if (!returnLocation.latitude || !returnLocation.longitude) {
      errors.returnLocation = "Return location is required";
    }


    setFieldErrors(errors);

    if (pickupTimeError || dropOffTimeError) {
      return false;
    }

    // Return false if there are validation errors OR if dates are invalid (already shown inline)
    return Object.keys(errors).length === 0 && !isSameDate;
  };

  const handleSubmit = (isAutoLoad = false) => {
    if (!isAutoLoad) {
      handleTrackButtonClick("Search_Submit");
    }
    if (!validateSearchForm()) {
      return;
    }
    let seatCapacity = null;
    let carType = null;
    let amountRange = 0;
    let modelYear = null;
    let Mileage = 0;

    if (customizeResult) {
      const { seat_capacity, car_type, amount_range, mileage, model_year } =
        customizeResult;
      seatCapacity = seat_capacity;
      carType = car_type;
      amountRange = amount_range;
      modelYear = model_year;
      Mileage = Number(mileage);
    }
    const convertToString = (value: number | null) =>
      value !== null ? value.toString() : "";

    const userData: ProductSearch = {
      index: 1,
      count: 10,
      sort_order: "ASC",
      is_landing_page: true,
      pickup_location: {
        latitude: convertToString(pickupLocation.latitude),
        longitude: convertToString(pickupLocation.longitude),
      },
      return_location: {
        latitude: convertToString(returnLocation.latitude),
        longitude: convertToString(returnLocation.longitude),
      },
      pickup_date: moment(pickupDate).format("YYYY-MM-DDT00:00:00.000") + "Z",
      dropOff_date: moment(dropOffDate).format("YYYY-MM-DDT00:00:00.000") + "Z",

      pickup_time: selectedTime,
      dropOff_time: selectedDropTime,
      ...(seatCapacity && { seat_capacity: seatCapacity }),
      ...(carType && { car_type: carType }),
      ...(amountRange !== 0 && { amount_range: amountRange.toFixed(1) }),
      ...(Mileage !== 0 && { mileage: Mileage.toFixed(1) }),
      ...(modelYear && { model_year: modelYear }),
      ...(carName.trim() && { product_name: carName.trim() }),
      isAutoLoad,
    };
    if (!isAutoLoad) {
      ReactPixel.track("Search", {
        content_type: "car_search",
        content_name: "Car Search",
        pickup_location: searchValues.pickup,
        return_location: searchValues.return,
        pickup_date: pickupDate,
        dropoff_date: dropOffDate,
        pickup_time: selectedTime,
        dropoff_time: selectedDropTime,
      });
      TagManager.dataLayer({
        dataLayer: {
          event: "search_submit",
          page_type: "home_page",
          page_path: window.location.pathname,
          page_url: window.location.href,
          search_source: "home_page",
          pickup_location: searchValues.pickup,
          pickup_datetime: `${pickupDate} ${selectedTime}`,
          dropoff_datetime: `${dropOffDate} ${selectedDropTime}`,
        }
      });
    }

    handleSearch.mutate(userData);
    setSearchMessage(null);
    setFieldErrors({});
  };

  let searchResultData: searchResult[] = [];

  const handleSearch = useMutation({
    mutationFn: (userData: ProductSearch) =>
      axiosInstance.post(API_URL.PRODUCT_SEARCH, userData),
    onSuccess: (successResponse, variables) => {
      searchResultData = successResponse.data;
      SetSearchCars(searchResultData);
      setSearchMessage(searchResultData[0]?.message || null);
      setSearchResultHeading(true);
      // Scroll smoothly to the results summary after the results DOM is painted
      if (!variables.isAutoLoad) {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            const target = resultsShellRef.current || searchFormRef.current;
            target?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          });
        });
      }
    },

    onError: (error) => {
      console.error("Search error:", error);
    },
  });

  const normalizeFilterValue = (value: any) =>
    String(value ?? "").trim().toUpperCase();

  const filterCatalog = useMemo(() => {
    const cars = Array.isArray(searchCars) ? searchCars : [];
    const priceValues = cars
      .map((car: any) => Number(car?.product_details_car?.price_per_day))
      .filter((price: number) => Number.isFinite(price) && price > 0);

    const weeklyPriceValues = cars
      .map((car: any) => Number(car?.product_details_car?.price_per_week))
      .filter((price: number) => Number.isFinite(price) && price > 0);

    const monthlyPriceValues = cars
      .map((car: any) => Number(car?.product_details_car?.price_per_month))
      .filter((price: number) => Number.isFinite(price) && price > 0);

    const uniqueSorted = (values: string[]) =>
      Array.from(new Set(values.filter(Boolean).map(v => v.toUpperCase()))).sort((a, b) =>
        a.localeCompare(b),
      );

    return {
      minPrice: priceValues.length ? Math.min(...priceValues) : 0,
      maxPrice: priceValues.length ? Math.max(...priceValues) : 0,
      minWeeklyPrice: weeklyPriceValues.length ? Math.min(...weeklyPriceValues) : 0,
      maxWeeklyPrice: weeklyPriceValues.length ? Math.max(...weeklyPriceValues) : 0,
      minMonthlyPrice: monthlyPriceValues.length ? Math.min(...monthlyPriceValues) : 0,
      maxMonthlyPrice: monthlyPriceValues.length ? Math.max(...monthlyPriceValues) : 0,
      carTypes: uniqueSorted(
        cars.map((car: any) =>
          car?.product_details_car?.car_type || car?.product_details_car?.category || "",
        ),
      ),
      brands: uniqueSorted(
        cars.map((car: any) =>
          car?.product_details_car?.car_brand ||
          car?.brand ||
          car?.product_name ||
          "",
        ),
      ),
      fuelTypes: uniqueSorted(
        cars.map((car: any) => car?.product_details_car?.fuel_type || ""),
      ),
      transmissions: uniqueSorted(
        cars.map((car: any) => car?.product_details_car?.transmission || ""),
      ),
    };
  }, [searchCars]);

  const filteredCars = useMemo(() => {
    const cars = Array.isArray(searchCars) ? searchCars : [];

    const minPrice = priceRange.min || 0;
    const maxPrice =
      priceRange.max || filterCatalog.maxPrice || Number.MAX_SAFE_INTEGER;
    const brandQuery = normalizeFilterValue(brandSearchQuery);

    return cars.filter((car: any) => {
      const price = Number(car?.product_details_car?.price_per_day || 0);
      const weeklyPrice = Number(car?.product_details_car?.price_per_week || 0);
      const monthlyPrice = Number(car?.product_details_car?.price_per_month || 0);
      const carType = normalizeFilterValue(
        car?.product_details_car?.car_type || car?.product_details_car?.category,
      );
      const brand = normalizeFilterValue(
        car?.product_details_car?.car_brand || car?.brand || car?.product_name,
      );
      const fuel = normalizeFilterValue(car?.product_details_car?.fuel_type);
      const transmission = normalizeFilterValue(
        car?.product_details_car?.transmission,
      );

      const priceMatches = price >= minPrice && price <= maxPrice;

      const weeklyPriceMatches =
        !weeklyPriceRange.max ||
        (weeklyPrice >= weeklyPriceRange.min && weeklyPrice <= weeklyPriceRange.max);

      const monthlyPriceMatches =
        !monthlyPriceRange.max ||
        (monthlyPrice >= monthlyPriceRange.min && monthlyPrice <= monthlyPriceRange.max);

      const brandMatches =
        !brandQuery ||
        brand.includes(brandQuery) ||
        normalizeFilterValue(car?.product_name).includes(brandQuery);
      const typeMatches =
        !selectedCarTypes.length ||
        selectedCarTypes.map(normalizeFilterValue).includes(carType);
      const brandFilterMatches =
        !selectedBrands.length ||
        selectedBrands.map(normalizeFilterValue).includes(brand);
      const fuelMatches =
        !selectedFuelTypes.length ||
        selectedFuelTypes.map(normalizeFilterValue).includes(fuel);
      const transmissionMatches =
        !selectedTransmissions.length ||
        selectedTransmissions.map(normalizeFilterValue).includes(transmission);
      const unlimitedMileageMatches =
        !isUnlimitedMileage || !car?.product_details_car?.mileage?.daily_mileage;

      return (
        priceMatches &&
        weeklyPriceMatches &&
        monthlyPriceMatches &&
        brandMatches &&
        typeMatches &&
        brandFilterMatches &&
        fuelMatches &&
        transmissionMatches &&
        unlimitedMileageMatches
      );
    });
  }, [
    brandSearchQuery,
    filterCatalog.maxPrice,
    filterCatalog.maxWeeklyPrice,
    filterCatalog.maxMonthlyPrice,
    normalizeFilterValue,
    priceRange.max,
    priceRange.min,
    weeklyPriceRange.max,
    weeklyPriceRange.min,
    monthlyPriceRange.max,
    monthlyPriceRange.min,
    searchCars,
    selectedBrands,
    selectedCarTypes,
    selectedFuelTypes,
    selectedTransmissions,
    isUnlimitedMileage,
  ]);

  const totalPages = Math.max(1, Math.ceil(filteredCars.length / itemsPerPage));
  const paginatedCars = filteredCars.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  useEffect(() => {
    setPriceRange({
      min: filterCatalog.minPrice,
      max: filterCatalog.maxPrice,
    });
    setWeeklyPriceRange({
      min: filterCatalog.minWeeklyPrice,
      max: filterCatalog.maxWeeklyPrice,
    });
    setMonthlyPriceRange({
      min: filterCatalog.minMonthlyPrice,
      max: filterCatalog.maxMonthlyPrice,
    });
    setSelectedCarTypes([]);
    setSelectedBrands([]);
    setSelectedFuelTypes([]);
    setSelectedTransmissions([]);
    setIsUnlimitedMileage(false);
    setBrandSearchQuery("");
    setCurrentPage(1);
  }, [filterCatalog.maxPrice, filterCatalog.minPrice, filterCatalog.maxWeeklyPrice, filterCatalog.minWeeklyPrice, filterCatalog.maxMonthlyPrice, filterCatalog.minMonthlyPrice, searchCars]);

  const navigate = useNavigate();

  const [carName, setCarName] = useState<string>("");
  const [showCreateProduct, setShowCreateProduct] = useState(false);

  const [showAcceptConfirmationModal, setShowAcceptConfirmationModal] =
    useState(false);

  const [acceptConfirmationMessage, setAcceptConfirmationMessage] =
    useState("");

  const handleOpenConfirmationModal = (message: string) => {
    setAcceptConfirmationMessage(message);
    setShowAcceptConfirmationModal(true);
  };

  const handleBookingClick = (item?: any) => {
    handleTrackButtonClick("Book_Now");
    if (item) {
      setSelectedBookingItem(item);

      const payload: any = {
        product_id: item?.product_id,
        base_product_id: item?.product_id,
        product_name: item?.product_name,
        product_description: item?.product_description,
        merchant_id: item?.merchant_id,
        quantity: 1,
        item_id: "",
        promotion_id: "",
        price: item?.product_details_car?.price_per_day,
        price_per_week: item?.product_details_car?.price_per_week,
        price_per_month: item?.product_details_car?.price_per_month,
        toppings: [],
        buy_more_pay_less: {},
        discount_event: {},
        variant: {},
        shop_id: item?.vendor_product_inventories?.[0]?.vendor_id || "",
        product_details: item?.product_details?.description,
      };

      if (process.env.REACT_APP_META_PIXEL_ID) {
        try {
          if (!(window as any).fbq) {
            ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
          }
          ReactPixel.track("AddToCart", {
            content_type: "Product",
            content_name: payload?.product_name,
            content_category: "Add to Cart",
            content_ids: [payload?.product_id],
          });
        } catch (_) { }
      }

      try {
        TagManager.dataLayer({
          dataLayer: {
            event: "add_to_cart",
            page_type: "standard",
            page_path: window.location.pathname,
            page_url: window.location.href,
            product_id: payload?.product_id,
            product_name: payload?.product_name
          }
        });
      } catch (_) { }

      trackEvent({
        event_name: {
          web: "Kirkos_Homepage_Add_To_Cart",
          app: "Kirkos_Homepage_Add_To_Cart",
        },
        event_category: "Homepage_Info",
        module: "HomePage",
        payload: payload,
      }).catch(() => { });
    }

    handleOpenConfirmationModal("Login to continue on this website");
    // const token = localStorage.getItem("access_token") || sessionStorage.getItem("access_token");
    // if (token) {
    //   const pendingSearchData = {
    //     pickupPlace: searchMessage ? "Dubai Marina, Dubai, United Arab Emirates" : searchValues.pickup,
    //     returnPlace: searchMessage ? "Dubai Marina, Dubai, United Arab Emirates" : searchValues.return,
    //     returnToSameLocation,
    //     pickupDate: pickupDate ? new Date(pickupDate) : pickupDate,
    //     dropOffDate: dropOffDate ? new Date(dropOffDate) : dropOffDate,
    //     selectedTime,
    //     selectedDropTime,
    //     pickupLocLatitude: searchMessage ? "25.0786415" : pickupLocation?.latitude?.toString(),
    //     pickupLocLongitude: searchMessage ? "55.1352524" : pickupLocation?.longitude?.toString(),
    //     returnLocLatitude: searchMessage ? "25.0786415" : returnLocation?.latitude?.toString(),
    //     returnLocLongitude: searchMessage ? "55.1352524" : returnLocation?.longitude?.toString(),
    //     customizeResult,
    //   };

    //   const bookingState = {
    //     selectedItem: item,
    //     merchantId: item.merchant_id,
    //     searchData: pendingSearchData,
    //     pickupCharge: item?.product_car_insurance?.pick_up_charge_outside_40km,
    //     deliveryCharge: item?.product_car_insurance?.delivery_charges_outside_40km,
    //   };

    //   navigate("/customer/unified-booking", {
    //     state: bookingState,
    //   });
    // } else {
    //   handleOpenConfirmationModal("Login to continue on this website");
    // }

  };

  useEffect(() => {
    // Only scroll if we have results and it's NOT an auto-load trigger
    if (searchResultHeading && !handleSearch.variables?.isAutoLoad) {
      // Scroll to results summary if it exists, otherwise fallback to form
      const target = resultsShellRef.current || searchFormRef.current;
      target?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [currentPage, searchResultHeading, handleSearch.variables?.isAutoLoad]);

  useEffect(() => {
    if (searchResultHeading) {
      window.history.pushState({ results: true }, "");
    }
  }, [searchResultHeading]);

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (searchResultHeading) {
        setSearchResultHeading(false);
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [searchResultHeading, setSearchResultHeading]);

  //------------------------------------------------------------------------------------------------------------------

  const homepageSchema = {
    "@context": "https://schema.org",
    "@type": "CarRental",
    "name": "Kirkos Car Rental",
    "url": "https://kirkos.ae",
    "logo": `${window.location.origin}${kirkos_logo_white_yellow}`,
    "image": `${window.location.origin}${car_home}`,
    "description": "Premium car rental services in Dubai and UAE. Rent luxury, economy, and commercial vehicles with ease.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Dubai",
      "addressCountry": "AE"
    },
    "telephone": "+971 6 569 9535",
    "priceRange": "$$",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "09:00",
        "closes": "22:00"
      }
    ]
  };

  return (
    <>
      <SEO
        title="Kirkos | Rent A Car & Make Your Trip Enjoyable"
        description="Premium car rental services in Dubai and beyond. Find luxury, economy, and commercial vehicles with Kirkos. Easy booking and reliable service."
        keywords="car rental dubai, rent a car, luxury car rental, commercial vehicle hire, Kirkos car rental"
        schemaData={homepageSchema}
      />
      <>
        <div className="col-12">
          <div className="landing-shell__hero">
            <div className="landing-shell__visual">
              <HomePageCarousel />
              <div className="landing-shell__search">
                <h1 className="landing-shell__title">
                  RENT A CAR &amp; <span>MAKE YOUR TRIP ENJOYABLE</span>
                </h1>
                <div className="landing-shell__search-body">

                  {/* ── Row 1: Return-to-same-location toggle ── */}
                  <div className="landing-shell__prefs-row">
                    <div className="d-flex align-items-center gap-3">
                      <div className="landing-shell__prefs-info">
                        <Funnel className="text-warning" size={14} />
                        <span>Quick Search Preferences</span>
                      </div>

                    </div>
                    <button
                      type="button"
                      className={`landing-shell__toggle ${returnToSameLocation ? "is-active" : ""}`}
                      onClick={handleToggleReturnToSameLocation}
                    >
                      {returnToSameLocation ? <Check2 size={14} className="me-1" /> : null}
                      Return to same location
                    </button>
                  </div>

                  {/* ── Row 2: Location pickers ── */}
                  <div className="row g-3 mb-3">
                    <div className={returnToSameLocation ? "col-12" : "col-12 col-lg-6"}>
                      <div className="position-relative">
                        <div onClick={() => setShowPickupMapModal(true)} style={{ cursor: "pointer" }}>
                          <FloatingInputLocation
                            inputType={"text"}
                            className={""}
                            placeholder={"Pick Up Location"}
                            label={"PICK UP LOCATION"}
                            inputName="pickUpLocation"
                            selectedLocationName={searchValues.pickup}
                            onInputChange={(value: string) => handlePickupLocationChange(value)}
                            control={control}
                            editable={false}
                          />
                        </div>
                        {fieldErrors.pickupLocation && (
                          <div className="text-danger mt-1" style={{ fontSize: "12px", fontWeight: "500" }}>
                            {fieldErrors.pickupLocation}
                          </div>
                        )}
                      </div>
                    </div>

                    {!returnToSameLocation && (
                      <div className="col-12 col-lg-6">
                        <div className="position-relative">
                          <div onClick={() => setShowReturnMapModal(true)} style={{ cursor: "pointer" }}>
                            <FloatingInputLocation
                              inputType={"text"}
                              className={""}
                              placeholder={"Return Location"}
                              label={"RETURN LOCATION"}
                              inputName="returnLocation"
                              onInputChange={(value: string) => handleReturnLocationChange(value)}
                              selectedLocationName={searchValues.return}
                              control={control}
                              editable={false}
                            />
                          </div>
                          {fieldErrors.returnLocation && (
                            <div className="text-danger mt-1" style={{ fontSize: "12px", fontWeight: "500" }}>
                              {fieldErrors.returnLocation}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* ── Row 3: Date/Time + Brand + Search ── */}
                  <div className="row g-3 align-items-end">
                    {/* Pick-up Date & Time */}
                    <div className="col-12 col-sm-6 col-lg-4">
                      <DateTimePickerComponent
                        label="Pick up Date & Time"
                        placeholder="Select date & time"
                        dateValue={pickupDate}
                        timeValue={selectedTime}
                        onDateChange={handlePickupDateChange}
                        onTimeChange={handleTimeChange}
                        className="w-100"
                        maxDate={dropOffDate ? new Date(dropOffDate) : null}
                        maxTime={pickupDate && dropOffDate && pickupDate === dropOffDate ? selectedDropTime : null}
                        minDate={(() => {
                          const today = new Date();
                          const currentHour = today.getHours();
                          const currentMinutes = today.getMinutes();
                          const isNoServiceToday = (currentHour * 60 + currentMinutes + 120 >= 22 * 60);
                          if (isNoServiceToday) {
                            const tom = new Date();
                            tom.setDate(tom.getDate() + 1);
                            return tom;
                          }
                          return today;
                        })()}
                        minTime={(() => {
                          // Only restrict the minimum time when the selected pickup date is TODAY.
                          // For tomorrow or any future date, all times are valid → return null.
                          if (!pickupDate) return null;
                          const today = new Date();
                          const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
                          if (pickupDate !== todayStr) return null;
                          const minTimeDate = new Date(today.getTime() + 2 * 60 * 60 * 1000);
                          const h = String(minTimeDate.getHours()).padStart(2, "0");
                          const m = String(minTimeDate.getMinutes()).padStart(2, "0");
                          return `${h}:${m}`;
                        })()}
                        showTodayPickupMessage={!!pickupDate && pickupDate === new Date().toISOString().split("T")[0]}
                        autoScrollToFirstAvailableTime={true}
                      />
                    </div>

                    {/* Drop-off Date & Time */}
                    <div className="col-12 col-sm-6 col-lg-4">
                      <DateTimePickerComponent
                        label="Dropoff Date & Time"
                        placeholder="Select date & time"
                        dateValue={dropOffDate}
                        timeValue={selectedDropTime}
                        onDateChange={handleDropOffDateChange}
                        onTimeChange={handleDropOffTimeChange}
                        className="w-100"
                        minDate={pickupDate ? new Date(pickupDate) : null}
                        minTime={pickupDate && dropOffDate && pickupDate === dropOffDate ? selectedTime : null}
                        maxDate={pickupDate ? (() => { const d = new Date(pickupDate); d.setDate(d.getDate() + 30); return d; })() : null}
                      />
                    </div>

                    {/* Brand Name */}
                    <div className="col-12 col-sm-8 col-lg-4 text-start">
                      <label htmlFor="homeCarSearch" className="landing-shell__label mb-1 d-block" style={{ fontSize: "0.85rem" }}>
                        Brand Name
                      </label>
                      <input
                        type="text"
                        id="homeCarSearch"
                        className="landing-shell__brand-input w-100 px-3"
                        placeholder="Brand (optional)"
                        style={{ height: "48px" }}
                        value={carName}
                        onChange={(e) => setCarName(e.target.value)}
                      />
                    </div>
                  </div>
                  {(pickupTimeError || dropOffTimeError || fieldErrors.pickupDate || fieldErrors.dropOffDate || fieldErrors.pickupTime || fieldErrors.dropOffTime) && (
                    <div className="landing-shell__error mt-4">
                      <div className="d-flex align-items-center gap-2">
                        <Tools size={16} />
                        <span>{pickupTimeError || dropOffTimeError || fieldErrors.pickupDate || fieldErrors.dropOffDate || fieldErrors.pickupTime || fieldErrors.dropOffTime}</span>
                      </div>
                    </div>
                  )}
                  <div className="row justify-content-end mt-2 align-items-end">
                    <div className="col-12 col-sm-4 col-lg-2 d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="landing-shell__clear-btn d-flex align-items-center gap-1"
                        onClick={handleClearSearch}
                        style={{
                          background: "transparent",
                          color: "#fff",
                          fontSize: "12px",
                          padding: "4px 0",
                          transition: "all 0.2s",
                          opacity: 0.8,
                          fontWeight: "500",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.opacity = "1")}
                        onMouseOut={(e) => (e.currentTarget.style.opacity = "0.8")}
                      >
                        <ArrowClockwise size={14} className={isRotating ? "is-rotating" : ""} />
                        Clear All
                      </button>
                    </div>
                    {/* Search button */}
                    <div className="col-12 col-sm-4 col-lg-2">
                      <button
                        className="landing-shell__search-button w-100"
                        onClick={() => handleSubmit()}
                      >
                        <Search size={18} className="me-2" />
                        SEARCH
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {isSameDate && (
            <div className="landing-shell__inline-error">
              Drop-off date must be later than Pick-up date. Please select a valid date.
            </div>
          )}

          <div id="searchResultSection" />
          <div
            className={`search-list-home home-search-min-height align-items-start ${searchResultHeading ? "" : "d-none"
              }`}
          >
            <div ref={resultsShellRef} className="home-results-shell col-12 col-xxl-11 mx-auto px-3 px-xl-4">
              <main className="home-results-main">
                <div className="home-results-summary">
                  <div className="home-results-summary__copy w-100">
                    <div className="home-results-summary__eyebrow">
                      Exclusive car collections
                    </div>
                    <h2>
                      {searchMessage
                        ? `No cars found in ${searchValues.pickup.split(",")[0]}. Showing top results from Dubai Marina.`
                        : searchValues.pickup === "Dubai Marina, Dubai, United Arab Emirates"
                          ? "Exclusive car collections in Dubai Marina"
                          : `Available cars in ${searchValues.pickup.split(",")[0]}`}
                    </h2>
                    {/* {searchMessage && (
                      <div className="home-results-summary__message text-warning mb-2">
                        {searchMessage}
                      </div>
                    )} */}
                    <div className="home-results-summary__meta d-flex align-items-center justify-content-center gap-2">
                      <Check2 className="text-warning" size={16} />
                      <span>{filteredCars.length} premium cars found for your dates</span>
                    </div>
                  </div>
                  {/* 📱 Mobile Filter Button & Applied Filters */}
                  <div className="home-mobile-filter-section d-lg-none w-100">
                    <div className="d-flex gap-2 align-items-center justify-content-between mb-3">
                      <button
                        className="home-mobile-filter-btn"
                        onClick={() => {
                          handleTrackButtonClick("Open_Mobile_Filters");
                          setShowFilterDrawer(true);
                        }}
                      >
                        <Funnel size={16} className="me-2" />
                        Filters
                      </button>
                      <button
                        type="button"
                        className="btn d-flex align-items-center gap-1 border-0"
                        onClick={resetFilters}
                        style={{
                          fontSize: "12px",
                          color: "#F0B64F",
                          background: "rgba(240, 182, 79, 0.1)",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          fontWeight: "600",
                          transition: "all 0.3s ease"
                        }}
                      >
                        <ArrowClockwise size={14} className={isRotating ? "is-rotating" : ""} />
                        Reset
                      </button>
                    </div>

                    {/* Applied Filters Mini-list */}
                    {(selectedCarTypes.length > 0 ||
                      selectedBrands.length > 0 ||
                      selectedFuelTypes.length > 0 ||
                      selectedTransmissions.length > 0 ||
                      priceRange.min > filterCatalog.minPrice ||
                      priceRange.max < filterCatalog.maxPrice ||
                      weeklyPriceRange.min > filterCatalog.minWeeklyPrice ||
                      weeklyPriceRange.max < filterCatalog.maxWeeklyPrice ||
                      monthlyPriceRange.min > filterCatalog.minMonthlyPrice ||
                      monthlyPriceRange.max < filterCatalog.maxMonthlyPrice) && (
                        <div className="home-results-applied home-results-applied--mobile">
                          <div className="home-results-applied__list">
                            {[...selectedCarTypes, ...selectedBrands, ...selectedFuelTypes, ...selectedTransmissions].map((val) => (
                              <button
                                key={val}
                                className="home-results-chip"
                                onClick={() => {
                                  if (selectedCarTypes.includes(val)) toggleFilterValue(val, setSelectedCarTypes);
                                  else if (selectedBrands.includes(val)) toggleFilterValue(val, setSelectedBrands);
                                  else if (selectedFuelTypes.includes(val)) toggleFilterValue(val, setSelectedFuelTypes);
                                  else if (selectedTransmissions.includes(val)) toggleFilterValue(val, setSelectedTransmissions);
                                }}
                              >
                                {val} <span className="ms-1">&times;</span>
                              </button>
                            ))}
                            {(priceRange.min > filterCatalog.minPrice || priceRange.max < filterCatalog.maxPrice) && (
                              <button
                                className="home-results-chip"
                                onClick={() => setPriceRange({ min: filterCatalog.minPrice, max: filterCatalog.maxPrice })}
                              >
                                Daily: AED {Math.round(priceRange.min)}-{Math.round(priceRange.max)} &times;
                              </button>
                            )}
                            {(weeklyPriceRange.min > filterCatalog.minWeeklyPrice || weeklyPriceRange.max < filterCatalog.maxWeeklyPrice) && (
                              <button
                                className="home-results-chip"
                                onClick={() => setWeeklyPriceRange({ min: filterCatalog.minWeeklyPrice, max: filterCatalog.maxWeeklyPrice })}
                              >
                                Weekly: AED {Math.round(weeklyPriceRange.min)}-{Math.round(weeklyPriceRange.max)} &times;
                              </button>
                            )}
                            {(monthlyPriceRange.min > filterCatalog.minMonthlyPrice || monthlyPriceRange.max < filterCatalog.maxMonthlyPrice) && (
                              <button
                                className="home-results-chip"
                                onClick={() => setMonthlyPriceRange({ min: filterCatalog.minMonthlyPrice, max: filterCatalog.maxMonthlyPrice })}
                              >
                                Monthly: AED {Math.round(monthlyPriceRange.min)}-{Math.round(monthlyPriceRange.max)} &times;
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                  </div>
                </div>

                {/* 💻 Desktop Filter Bar */}
                <div className="home-results-topbar d-none d-lg-block">
                  <div className="home-results-filter-header">
                    <div className="home-results-topbar__title">
                      <Funnel size={16} />
                      <span>Filters</span>
                    </div>
                    <button type="button" className="home-results-reset-slim d-flex align-items-center gap-1" onClick={resetFilters}>
                      <ArrowClockwise size={12} className={isRotating ? "is-rotating" : ""} />
                      Reset All
                    </button>
                  </div>

                  <div className="home-results-topbar__flex">
                    <div className="home-results-filter home-results-filter--compact">
                      <div className="home-results-filter__label">Daily Price</div>
                      <details
                        className="home-results-combo"
                        open={activeFilter === "price"}
                      >
                        <summary
                          className="home-results-combo__summary"
                          onClick={(e) => {
                            e.preventDefault();
                            setActiveFilter(activeFilter === "price" ? null : "price");
                          }}
                        >
                          <span className="home-results-combo__value">
                            {priceRange.min > filterCatalog.minPrice || priceRange.max < filterCatalog.maxPrice
                              ? `AED ${priceRange.min} - ${priceRange.max}`
                              : "Any Price"}
                          </span>
                        </summary>
                        <div className="home-results-combo__panel">
                          <div className="p-3" style={{ minWidth: "260px" }}>
                            <div className="home-results-filter__label mb-3">Daily: AED {Math.round(priceRange.min)} - {Math.round(priceRange.max)}</div>
                            <div className="home-results-slider-wrapper">
                              <div className="home-results-slider-track" />
                              <div
                                className="home-results-slider-range"
                                style={{
                                  left: `${((priceRange.min - filterCatalog.minPrice) / (filterCatalog.maxPrice - filterCatalog.minPrice || 1)) * 100}%`,
                                  right: `${100 - ((priceRange.max - filterCatalog.minPrice) / (filterCatalog.maxPrice - filterCatalog.minPrice || 1)) * 100}%`
                                }}
                              />
                              <input
                                type="range"
                                min={filterCatalog.minPrice}
                                max={filterCatalog.maxPrice || filterCatalog.minPrice || 0}
                                value={priceRange.min || filterCatalog.minPrice || 0}
                                onChange={(e) => {
                                  const val = Math.min(Number(e.target.value), priceRange.max - 1);
                                  handleDailyPriceChange(val, priceRange.max);
                                }}
                                className="home-results-slider"
                              />
                              <input
                                type="range"
                                min={filterCatalog.minPrice}
                                max={filterCatalog.maxPrice || filterCatalog.minPrice || 0}
                                value={priceRange.max || filterCatalog.maxPrice || 0}
                                onChange={(e) => {
                                  const val = Math.max(Number(e.target.value), priceRange.min + 1);
                                  handleDailyPriceChange(priceRange.min, val);
                                }}
                                className="home-results-slider"
                              />
                            </div>
                            <div className="home-results-range-group">
                              <div className="home-results-range-box">
                                <label>MIN (AED)</label>
                                <input
                                  type="text"
                                  value={Math.round(priceRange.min)}
                                  onChange={(e) => {
                                    const val = e.target.value.replace(/[^0-9]/g, "");
                                    handleDailyPriceChange(val === "" ? 0 : Number(val), priceRange.max);
                                  }}
                                />
                              </div>
                              <div className="home-results-range-box">
                                <label>MAX (AED)</label>
                                <input
                                  type="text"
                                  value={Math.round(priceRange.max)}
                                  onChange={(e) => {
                                    const val = e.target.value.replace(/[^0-9]/g, "");
                                    handleDailyPriceChange(priceRange.min, val === "" ? 0 : Number(val));
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </details>
                    </div>

                    <div className="home-results-filter home-results-filter--compact">
                      <div className="home-results-filter__label">Weekly Price</div>
                      <details
                        className="home-results-combo"
                        open={activeFilter === "weeklyPrice"}
                      >
                        <summary
                          className="home-results-combo__summary"
                          onClick={(e) => {
                            e.preventDefault();
                            setActiveFilter(activeFilter === "weeklyPrice" ? null : "weeklyPrice");
                          }}
                        >
                          <span className="home-results-combo__value">
                            {weeklyPriceRange.min > filterCatalog.minWeeklyPrice || weeklyPriceRange.max < filterCatalog.maxWeeklyPrice
                              ? `AED ${weeklyPriceRange.min} - ${weeklyPriceRange.max}`
                              : "Any Price"}
                          </span>
                        </summary>
                        <div className="home-results-combo__panel">
                          <div className="p-3" style={{ minWidth: "260px" }}>
                            <div className="home-results-filter__label mb-3">Weekly: AED {Math.round(weeklyPriceRange.min)} - {Math.round(weeklyPriceRange.max)}</div>
                            <div className="home-results-slider-wrapper">
                              <div className="home-results-slider-track" />
                              <div
                                className="home-results-slider-range"
                                style={{
                                  left: `${((weeklyPriceRange.min - filterCatalog.minWeeklyPrice) / (filterCatalog.maxWeeklyPrice - filterCatalog.minWeeklyPrice || 1)) * 100}%`,
                                  right: `${100 - ((weeklyPriceRange.max - filterCatalog.minWeeklyPrice) / (filterCatalog.maxWeeklyPrice - filterCatalog.minWeeklyPrice || 1)) * 100}%`
                                }}
                              />
                              <input
                                type="range"
                                min={filterCatalog.minWeeklyPrice}
                                max={filterCatalog.maxWeeklyPrice || filterCatalog.minWeeklyPrice || 0}
                                value={weeklyPriceRange.min || filterCatalog.minWeeklyPrice || 0}
                                onChange={(e) => {
                                  const val = Math.min(Number(e.target.value), weeklyPriceRange.max - 1);
                                  handleWeeklyPriceChange(val, weeklyPriceRange.max);
                                }}
                                className="home-results-slider"
                              />
                              <input
                                type="range"
                                min={filterCatalog.minWeeklyPrice}
                                max={filterCatalog.maxWeeklyPrice || filterCatalog.minWeeklyPrice || 0}
                                value={weeklyPriceRange.max || filterCatalog.maxWeeklyPrice || 0}
                                onChange={(e) => {
                                  const val = Math.max(Number(e.target.value), weeklyPriceRange.min + 1);
                                  handleWeeklyPriceChange(weeklyPriceRange.min, val);
                                }}
                                className="home-results-slider"
                              />
                            </div>
                            <div className="home-results-range-group">
                              <div className="home-results-range-box">
                                <label>MIN (AED)</label>
                                <input
                                  type="text"
                                  value={Math.round(weeklyPriceRange.min)}
                                  onChange={(e) => {
                                    const val = e.target.value.replace(/[^0-9]/g, "");
                                    handleWeeklyPriceChange(val === "" ? 0 : Number(val), weeklyPriceRange.max);
                                  }}
                                />
                              </div>
                              <div className="home-results-range-box">
                                <label>MAX (AED)</label>
                                <input
                                  type="text"
                                  value={Math.round(weeklyPriceRange.max)}
                                  onChange={(e) => {
                                    const val = e.target.value.replace(/[^0-9]/g, "");
                                    handleWeeklyPriceChange(weeklyPriceRange.min, val === "" ? 0 : Number(val));
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </details>
                    </div>

                    <div className="home-results-filter home-results-filter--compact">
                      <div className="home-results-filter__label">Monthly Price</div>
                      <details
                        className="home-results-combo"
                        open={activeFilter === "monthlyPrice"}
                      >
                        <summary
                          className="home-results-combo__summary"
                          onClick={(e) => {
                            e.preventDefault();
                            setActiveFilter(activeFilter === "monthlyPrice" ? null : "monthlyPrice");
                          }}
                        >
                          <span className="home-results-combo__value">
                            {monthlyPriceRange.min > filterCatalog.minMonthlyPrice || monthlyPriceRange.max < filterCatalog.maxMonthlyPrice
                              ? `AED ${monthlyPriceRange.min} - ${monthlyPriceRange.max}`
                              : "Any Price"}
                          </span>
                        </summary>
                        <div className="home-results-combo__panel">
                          <div className="p-3" style={{ minWidth: "260px" }}>
                            <div className="home-results-filter__label mb-3">Monthly: AED {Math.round(monthlyPriceRange.min)} - {Math.round(monthlyPriceRange.max)}</div>
                            <div className="home-results-slider-wrapper">
                              <div className="home-results-slider-track" />
                              <div
                                className="home-results-slider-range"
                                style={{
                                  left: `${((monthlyPriceRange.min - filterCatalog.minMonthlyPrice) / (filterCatalog.maxMonthlyPrice - filterCatalog.minMonthlyPrice || 1)) * 100}%`,
                                  right: `${100 - ((monthlyPriceRange.max - filterCatalog.minMonthlyPrice) / (filterCatalog.maxMonthlyPrice - filterCatalog.minMonthlyPrice || 1)) * 100}%`
                                }}
                              />
                              <input
                                type="range"
                                min={filterCatalog.minMonthlyPrice}
                                max={filterCatalog.maxMonthlyPrice || filterCatalog.minMonthlyPrice || 0}
                                value={monthlyPriceRange.min || filterCatalog.minMonthlyPrice || 0}
                                onChange={(e) => {
                                  const val = Math.min(Number(e.target.value), monthlyPriceRange.max - 1);
                                  handleMonthlyPriceChange(val, monthlyPriceRange.max);
                                }}
                                className="home-results-slider"
                              />
                              <input
                                type="range"
                                min={filterCatalog.minMonthlyPrice}
                                max={filterCatalog.maxMonthlyPrice || filterCatalog.minMonthlyPrice || 0}
                                value={monthlyPriceRange.max || filterCatalog.maxMonthlyPrice || 0}
                                onChange={(e) => {
                                  const val = Math.max(Number(e.target.value), monthlyPriceRange.min + 1);
                                  handleMonthlyPriceChange(monthlyPriceRange.min, val);
                                }}
                                className="home-results-slider"
                              />
                            </div>
                            <div className="home-results-range-group">
                              <div className="home-results-range-box">
                                <label>MIN (AED)</label>
                                <input
                                  type="text"
                                  value={Math.round(monthlyPriceRange.min)}
                                  onChange={(e) => {
                                    const val = e.target.value.replace(/[^0-9]/g, "");
                                    handleMonthlyPriceChange(val === "" ? 0 : Number(val), monthlyPriceRange.max);
                                  }}
                                />
                              </div>
                              <div className="home-results-range-box">
                                <label>MAX (AED)</label>
                                <input
                                  type="text"
                                  value={Math.round(monthlyPriceRange.max)}
                                  onChange={(e) => {
                                    const val = e.target.value.replace(/[^0-9]/g, "");
                                    handleMonthlyPriceChange(monthlyPriceRange.min, val === "" ? 0 : Number(val));
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </details>
                    </div>

                    <div className="home-results-filter home-results-filter--compact">
                      <div className="home-results-filter__label">Car type</div>
                      <details
                        className="home-results-combo"
                        open={activeFilter === "type"}
                      >
                        <summary
                          className="home-results-combo__summary"
                          onClick={(e) => {
                            e.preventDefault();
                            setActiveFilter(activeFilter === "type" ? null : "type");
                          }}
                        >
                          <span className="home-results-combo__value">
                            {selectedCarTypes.length
                              ? `${selectedCarTypes.length} types`
                              : "All types"}
                          </span>
                        </summary>
                        <div className="home-results-combo__panel">
                          <div className="home-results-tags p-2" style={{ minWidth: "200px" }}>
                            {filterCatalog.carTypes.map((type) => (
                              <button
                                key={type}
                                type="button"
                                className={`home-results-tag ${selectedCarTypes.includes(type) ? "is-active" : ""}`}
                                onClick={() => toggleFilterValue(type, setSelectedCarTypes)}
                              >
                                {type}
                              </button>
                            ))}
                          </div>
                        </div>
                      </details>
                    </div>

                    <div className="home-results-filter home-results-filter--compact">
                      <div className="home-results-filter__label">Brand</div>
                      <details
                        className="home-results-combo"
                        open={activeFilter === "brand"}
                      >
                        <summary
                          className="home-results-combo__summary"
                          onClick={(e) => {
                            e.preventDefault();
                            setActiveFilter(activeFilter === "brand" ? null : "brand");
                          }}
                        >
                          <span className="home-results-combo__value">
                            {selectedBrands.length
                              ? `${selectedBrands.length} selected`
                              : "All brands"}
                          </span>
                        </summary>
                        <div className="home-results-combo__panel">
                          <div className="p-2" style={{ minWidth: "240px" }}>
                            <div className="home-results-search mb-2">
                              <Search size={14} />
                              <input
                                type="text"
                                placeholder="Search brand"
                                value={brandSearchQuery}
                                onChange={(e) => setBrandSearchQuery(e.target.value)}
                              />
                            </div>
                            <div className="home-results-checklist">
                              {filterCatalog.brands.map((brand) => (
                                <label key={brand} className="home-results-check">
                                  <input
                                    type="checkbox"
                                    checked={selectedBrands.includes(brand)}
                                    onChange={() => toggleFilterValue(brand, setSelectedBrands)}
                                  />
                                  <span>{brand}</span>
                                </label>
                              ))}
                            </div>
                          </div>
                        </div>
                      </details>
                    </div>

                    <div className="home-results-filter home-results-filter--compact">
                      <div className="home-results-filter__label">Fuel type</div>
                      <details
                        className="home-results-combo"
                        open={activeFilter === "fuel"}
                      >
                        <summary
                          className="home-results-combo__summary"
                          onClick={(e) => {
                            e.preventDefault();
                            setActiveFilter(activeFilter === "fuel" ? null : "fuel");
                          }}
                        >
                          <span className="home-results-combo__value">
                            {selectedFuelTypes.length
                              ? `${selectedFuelTypes.length} fuel`
                              : "All fuel"}
                          </span>
                        </summary>
                        <div className="home-results-combo__panel">
                          <div className="home-results-checklist p-2" style={{ minWidth: "180px" }}>
                            {filterCatalog.fuelTypes.map((fuel) => (
                              <label key={fuel} className="home-results-check">
                                <input
                                  type="checkbox"
                                  checked={selectedFuelTypes.includes(fuel)}
                                  onChange={() => toggleFilterValue(fuel, setSelectedFuelTypes)}
                                />
                                <span>{fuel}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      </details>
                    </div>

                    <div className="home-results-filter home-results-filter--compact">
                      <div className="home-results-filter__label">Trans.</div>
                      <details
                        className="home-results-combo"
                        open={activeFilter === "transmission"}
                      >
                        <summary
                          className="home-results-combo__summary"
                          onClick={(e) => {
                            e.preventDefault();
                            setActiveFilter(activeFilter === "transmission" ? null : "transmission");
                          }}
                        >
                          <span className="home-results-combo__value">
                            {selectedTransmissions.length
                              ? `${selectedTransmissions.length} sel.`
                              : "All"}
                          </span>
                        </summary>
                        <div className="home-results-combo__panel">
                          <div className="home-results-checklist p-2" style={{ minWidth: "160px" }}>
                            {filterCatalog.transmissions.map((transmission) => (
                              <label key={transmission} className="home-results-check">
                                <input
                                  type="checkbox"
                                  checked={selectedTransmissions.includes(transmission)}
                                  onChange={() => toggleFilterValue(transmission, setSelectedTransmissions)}
                                />
                                <span>{transmission}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      </details>
                    </div>

                    <div className="home-results-filter home-results-filter--compact">
                      <div className="home-results-filter__label">Mileage</div>
                      <details
                        className="home-results-combo"
                        open={activeFilter === "mileage"}
                      >
                        <summary
                          className="home-results-combo__summary"
                          onClick={(e) => {
                            e.preventDefault();
                            setActiveFilter(activeFilter === "mileage" ? null : "mileage");
                          }}
                        >
                          <span className="home-results-combo__value">
                            {isUnlimitedMileage ? "Unlimited" : "All"}
                          </span>
                        </summary>
                        <div className="home-results-combo__panel">
                          <div className="p-2" style={{ minWidth: "180px" }}>
                            <label className="home-results-check">
                              <input
                                type="checkbox"
                                checked={isUnlimitedMileage}
                                onChange={() => {
                                  setIsUnlimitedMileage(!isUnlimitedMileage);
                                  setCurrentPage(1);
                                }}
                              />
                              <span>UNLIMITED MILEAGE</span>
                            </label>
                          </div>
                        </div>
                      </details>
                    </div>
                  </div>

                  {(selectedCarTypes.length > 0 ||
                    selectedBrands.length > 0 ||
                    selectedFuelTypes.length > 0 ||
                    selectedTransmissions.length > 0 ||
                    isUnlimitedMileage ||
                    priceRange.min > filterCatalog.minPrice ||
                    priceRange.max < filterCatalog.maxPrice ||
                    weeklyPriceRange.min > filterCatalog.minWeeklyPrice ||
                    weeklyPriceRange.max < filterCatalog.maxWeeklyPrice ||
                    monthlyPriceRange.min > filterCatalog.minMonthlyPrice ||
                    monthlyPriceRange.max < filterCatalog.maxMonthlyPrice) && (
                      <div className="home-results-applied">
                        <div className="home-results-applied__label">Applied Filters:</div>
                        <div className="home-results-applied__list">
                          {selectedCarTypes.map((val) => (
                            <button
                              key={val}
                              className="home-results-chip"
                              onClick={() => toggleFilterValue(val, setSelectedCarTypes)}
                            >
                              {val} <span className="ms-1">&times;</span>
                            </button>
                          ))}
                          {selectedBrands.map((val) => (
                            <button
                              key={val}
                              className="home-results-chip"
                              onClick={() => toggleFilterValue(val, setSelectedBrands)}
                            >
                              {val} <span className="ms-1">&times;</span>
                            </button>
                          ))}
                          {selectedFuelTypes.map((val) => (
                            <button
                              key={val}
                              className="home-results-chip"
                              onClick={() => toggleFilterValue(val, setSelectedFuelTypes)}
                            >
                              {val} <span className="ms-1">&times;</span>
                            </button>
                          ))}
                          {selectedTransmissions.map((val) => (
                            <button
                              key={val}
                              className="home-results-chip"
                              onClick={() => toggleFilterValue(val, setSelectedTransmissions)}
                            >
                              {val} <span className="ms-1">&times;</span>
                            </button>
                          ))}
                          {isUnlimitedMileage && (
                            <button
                              className="home-results-chip"
                              onClick={() => setIsUnlimitedMileage(false)}
                            >
                              UNLIMITED MILEAGE <span className="ms-1">&times;</span>
                            </button>
                          )}
                          {(priceRange.min > filterCatalog.minPrice ||
                            priceRange.max < filterCatalog.maxPrice) && (
                              <button
                                className="home-results-chip"
                                onClick={() =>
                                  setPriceRange({
                                    min: filterCatalog.minPrice,
                                    max: filterCatalog.maxPrice,
                                  })
                                }
                              >
                                Daily: AED {Math.round(priceRange.min)} - {Math.round(priceRange.max)}{" "}
                                <span className="ms-1">&times;</span>
                              </button>
                            )}
                          {(weeklyPriceRange.min > filterCatalog.minWeeklyPrice ||
                            weeklyPriceRange.max < filterCatalog.maxWeeklyPrice) && (
                              <button
                                className="home-results-chip"
                                onClick={() =>
                                  setWeeklyPriceRange({
                                    min: filterCatalog.minWeeklyPrice,
                                    max: filterCatalog.maxWeeklyPrice,
                                  })
                                }
                              >
                                Weekly: AED {Math.round(weeklyPriceRange.min)} - {Math.round(weeklyPriceRange.max)}{" "}
                                <span className="ms-1">&times;</span>
                              </button>
                            )}
                          {(monthlyPriceRange.min > filterCatalog.minMonthlyPrice ||
                            monthlyPriceRange.max < filterCatalog.maxMonthlyPrice) && (
                              <button
                                className="home-results-chip"
                                onClick={() =>
                                  setMonthlyPriceRange({
                                    min: filterCatalog.minMonthlyPrice,
                                    max: filterCatalog.maxMonthlyPrice,
                                  })
                                }
                              >
                                Monthly: AED {Math.round(monthlyPriceRange.min)} - {Math.round(monthlyPriceRange.max)}{" "}
                                <span className="ms-1">&times;</span>
                              </button>
                            )}
                        </div>
                      </div>
                    )}
                </div>

                {/* 📱 Mobile Filter Drawer (Offcanvas) */}
                <Offcanvas
                  show={showFilterDrawer}
                  onHide={() => setShowFilterDrawer(false)}
                  placement="bottom"
                  className="home-filter-drawer"
                  style={{ height: '85vh', borderTopLeftRadius: '24px', borderTopRightRadius: '24px' }}
                >
                  <Offcanvas.Header closeButton closeVariant="white">
                    <Offcanvas.Title className="text-white">Filters</Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body className="p-0">
                    <div className="p-4 bg-dark h-100 overflow-auto">
                      {/* Daily Price Range Section */}
                      <div className="mb-4">
                        <label className="text-warning small fw-bold text-uppercase mb-3 d-block">Daily Price Range (AED)</label>
                        <input
                          type="range"
                          min={filterCatalog.minPrice}
                          max={filterCatalog.maxPrice || filterCatalog.minPrice || 0}
                          value={priceRange.max || filterCatalog.maxPrice || 0}
                          onChange={(e) => handleDailyPriceChange(priceRange.min, Number(e.target.value))}
                          className="home-results-slider mb-4"
                        />
                        <div className="home-results-range-group">
                          <div className="home-results-range-box">
                            <label>MIN</label>
                            <input type="text" value={Math.round(priceRange.min)} readOnly />
                          </div>
                          <div className="home-results-range-box">
                            <label>MAX</label>
                            <input type="text" value={Math.round(priceRange.max)} readOnly />
                          </div>
                        </div>
                      </div>

                      {/* Weekly Price Range Section */}
                      <div className="mb-4">
                        <label className="text-warning small fw-bold text-uppercase mb-3 d-block">Weekly Price Range (AED)</label>
                        <input
                          type="range"
                          min={filterCatalog.minWeeklyPrice}
                          max={filterCatalog.maxWeeklyPrice || filterCatalog.minWeeklyPrice || 0}
                          value={weeklyPriceRange.max || filterCatalog.maxWeeklyPrice || 0}
                          onChange={(e) => handleWeeklyPriceChange(weeklyPriceRange.min, Number(e.target.value))}
                          className="home-results-slider mb-4"
                        />
                        <div className="home-results-range-group">
                          <div className="home-results-range-box">
                            <label>MIN</label>
                            <input type="text" value={Math.round(weeklyPriceRange.min)} readOnly />
                          </div>
                          <div className="home-results-range-box">
                            <label>MAX</label>
                            <input type="text" value={Math.round(weeklyPriceRange.max)} readOnly />
                          </div>
                        </div>
                      </div>

                      {/* Monthly Price Range Section */}
                      <div className="mb-4">
                        <label className="text-warning small fw-bold text-uppercase mb-3 d-block">Monthly Price Range (AED)</label>
                        <input
                          type="range"
                          min={filterCatalog.minMonthlyPrice}
                          max={filterCatalog.maxMonthlyPrice || filterCatalog.minMonthlyPrice || 0}
                          value={monthlyPriceRange.max || filterCatalog.maxMonthlyPrice || 0}
                          onChange={(e) => handleMonthlyPriceChange(monthlyPriceRange.min, Number(e.target.value))}
                          className="home-results-slider mb-4"
                        />
                        <div className="home-results-range-group">
                          <div className="home-results-range-box">
                            <label>MIN</label>
                            <input type="text" value={Math.round(monthlyPriceRange.min)} readOnly />
                          </div>
                          <div className="home-results-range-box">
                            <label>MAX</label>
                            <input type="text" value={Math.round(monthlyPriceRange.max)} readOnly />
                          </div>
                        </div>
                      </div>

                      {/* Car Type Section */}
                      <div className="mb-4">
                        <label className="text-warning small fw-bold text-uppercase mb-3 d-block">Car Type</label>
                        <div className="home-results-tags">
                          {filterCatalog.carTypes.map((type) => (
                            <button
                              key={type}
                              className={`home-results-tag ${selectedCarTypes.includes(type) ? "is-active" : ""}`}
                              onClick={() => toggleFilterValue(type, setSelectedCarTypes)}
                            >
                              {type}
                            </button>
                          ))}
                        </div>
                      </div>

                      {/* Brands Section */}
                      <div className="mb-4">
                        <label className="text-warning small fw-bold text-uppercase mb-3 d-block">Brands</label>
                        <div className="home-results-checklist">
                          {filterCatalog.brands.map((brand) => (
                            <label key={brand} className="home-results-check">
                              <input
                                type="checkbox"
                                checked={selectedBrands.includes(brand)}
                                onChange={() => toggleFilterValue(brand, setSelectedBrands)}
                              />
                              <span>{brand}</span>
                            </label>
                          ))}
                        </div>
                      </div>

                      {/* Transmission Section */}
                      <div className="mb-4">
                        <label className="text-warning small fw-bold text-uppercase mb-3 d-block">Transmission</label>
                        <div className="home-results-checklist">
                          {filterCatalog.transmissions.map((t) => (
                            <label key={t} className="home-results-check">
                              <input
                                type="checkbox"
                                checked={selectedTransmissions.includes(t)}
                                onChange={() => toggleFilterValue(t, setSelectedTransmissions)}
                              />
                              <span>{t}</span>
                            </label>
                          ))}
                        </div>
                      </div>

                      {/* Mileage Section */}
                      <div className="mb-5">
                        <label className="text-warning small fw-bold text-uppercase mb-3 d-block">Mileage</label>
                        <div className="home-results-checklist">
                          <label className="home-results-check">
                            <input
                              type="checkbox"
                              checked={isUnlimitedMileage}
                              onChange={() => setIsUnlimitedMileage(!isUnlimitedMileage)}
                            />
                            <span>Unlimited Mileage</span>
                          </label>
                        </div>
                      </div>

                      <div className="sticky-bottom p-3 bg-dark border-top border-secondary">
                        <button className="btn btn-warning w-100 fw-bold py-3 text-dark rounded-pill" onClick={() => setShowFilterDrawer(false)}>
                          APPLY {filteredCars.length} CARS
                        </button>
                      </div>
                    </div>
                  </Offcanvas.Body>
                </Offcanvas>

                {handleSearch.isPending ? (
                  <div className="home-results-empty text-center py-5">
                    <div className="spinner-border text-warning" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : filteredCars.length === 0 ? (
                  <div className="home-results-empty">
                    <p>No cars match the current filters.</p>
                  </div>
                ) : (
                  <>
                    <div className="home-results-grid">
                      {paginatedCars.map((item: any, index: number) => (
                        <div key={`${item.product_id || index}`} className="home-result-card-wrap ">
                          <div className="card card-custom-my-account scale-down home-result-card">
                            <div
                              className="position-relative"
                              onClick={(e) => {
                                handleTrackButtonClick("View_Details");
                                e.preventDefault();
                                setSelectedProduct(item);
                                setShowDetailsModal(true);
                                TagManager.dataLayer({
                                  dataLayer: {
                                    event: "car_detail_view",
                                    page_type: "product_listing",
                                    page_path: window.location.pathname,
                                    page_url: window.location.href,
                                    product_id: item?.product_id,
                                    product_name: item?.product_name,
                                    car_brand: item?.product_details_car?.car_brand,
                                    price_per_day: item?.product_details_car?.price_per_day,
                                  }
                                });
                              }}>
                              {item?.product_details?.images?.length > 0 ? (
                                <img
                                  className="img-fluid search-result-image home-result-card__image"
                                  src={item.product_details.images[0]}
                                  alt=""
                                />
                              ) : (
                                <img
                                  src={noun_no_image}
                                  alt=""
                                  className="img-fluid search-result-image home-result-card__image"
                                />
                              )}
                              {/* Glassmorphic overlay for tags */}
                              {item?.tags && Array.isArray(item.tags) && item.tags.length > 0 && (
                                <div
                                  className="position-absolute d-flex flex-wrap gap-1"
                                  style={{
                                    top: "10px",
                                    left: "10px",
                                    zIndex: 10,
                                    pointerEvents: "none"
                                  }}
                                >
                                  {item.tags.map((tag: string, tagIdx: number) => {
                                    const tagLower = tag.toLowerCase();
                                    let style: React.CSSProperties = {
                                      fontSize: "0.6rem",
                                      fontFamily: "Poppins, sans-serif",
                                      fontWeight: 800,
                                      textTransform: "uppercase",
                                      letterSpacing: "0.7px",
                                      padding: "0.2rem 0.6rem",
                                      borderRadius: "6px",
                                      backdropFilter: "blur(6px)",
                                      lineHeight: 1.5,
                                      whiteSpace: "nowrap",
                                      // default (fallback)
                                      background: "rgba(18, 21, 28, 0.85)",
                                      color: "#f0b64f",
                                      border: "1px solid rgba(240, 182, 79, 0.5)",
                                      boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                                    };

                                    return (
                                      <span
                                        key={`${tag}-${tagIdx}`}
                                        style={style}
                                      >
                                        {tag}
                                      </span>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                            <div className="card-body home-result-card__body">
                              <div className="row text-start">
                                <div className="col-6">
                                  <div className="car-cat-search home-result-card__brand" title={item?.product_name}>
                                    {initCapAllWords(item.product_name)}
                                  </div>
                                  <div className="car-name-search home-result-card__name" title={item?.product_name}>
                                    {initCapAllWords(item.product_name)}
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="text-center merchant-name-div mx-2 mb-1 home-result-card__merchant-box">
                                    <span className="home-result-card__merchant">
                                      {item?.site_logo ? (
                                        <img className="img-fluid logo-merchant" src={item?.site_logo} alt="" />
                                      ) : (
                                        <span title={item?.shop_name}>
                                          {String(item?.shop_name).length > 10
                                            ? `${String(item?.shop_name).substring(0, 10).toUpperCase()}...`
                                            : String(item?.shop_name).toUpperCase()}
                                        </span>
                                      )}
                                    </span>
                                  </div>
                                  <div className="text-center mx-2">
                                    <div className="merchant-name-container font-size-home-12 home-result-card__merchant-name" title={item?.shop_name}>
                                      {item?.shop_name}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row pt-2 search-features align-items-center home-result-card__features-row">
                                <div className="col-6">
                                  <div className="col-md-12 text-start pb-2 dashboard-poppins-font-style car-name-search-bold">
                                    Features
                                  </div>
                                  <div className="d-flex">
                                    <div className="text-start dashboard-poppins-font-style me-2 home-result-card__feature-item">
                                      <img src={group_icon} alt="" className="img-fluid img-width-icon" />
                                      &nbsp;{item.product_details_car.number_of_seats}
                                    </div>
                                    <div className="text-start dashboard-poppins-font-style home-result-card__feature-item">
                                      <img src={petrol_pump} alt="" className="img-fluid img-width-icon" />
                                      &nbsp;{item.product_details_car.fuel_type}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="search-car-special-deal text-center home-result-card__badge">
                                    <img src={dashboard_special_deal} alt="" width={13} />
                                    <span className="dashboard-poppins-font-style"> Special Deal </span>
                                  </div>
                                </div>
                              </div>
                              <div className="row text-start pt-2 home-result-card__pricing-row">
                                <div className="col-4">
                                  <div className="font-size-home-14 dashboard-poppins-font-style home-result-card__price">
                                    AED <span>{item.product_details_car.price_per_day}</span>
                                  </div>
                                  <div className="car-name-search-bold dashboard-poppins-font-style home-result-card__period">
                                    Per Day
                                  </div>
                                  <div className="car-name-search-bold dashboard-poppins-font-style home-result-card__mileage">
                                    {item?.product_details_car?.mileage?.daily_mileage ? (
                                      `${item.product_details_car.mileage.daily_mileage} KM`
                                    ) : (
                                      <div className="car-name-search dashboard-poppins-font-style">
                                        Unlimited mileage
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-4">
                                  <div className="font-size-home-14 dashboard-poppins-font-style home-result-card__price">
                                    AED <span>{item.product_details_car.price_per_week}</span>
                                  </div>
                                  <div className="car-name-search dashboard-poppins-font-style home-result-card__period">
                                    Per Week
                                  </div>
                                  <div className="car-name-search-bold dashboard-poppins-font-style home-result-card__mileage">
                                    {item?.product_details_car?.mileage?.weekly_mileage ? (
                                      `${item.product_details_car.mileage.weekly_mileage} KM`
                                    ) : (
                                      <div className="car-name-search dashboard-poppins-font-style">
                                        Unlimited mileage
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-4">
                                  <div className="font-size-home-14 dashboard-poppins-font-style home-result-card__price">
                                    AED <span>{item.product_details_car.price_per_month}</span>
                                  </div>
                                  <div className="car-name-search dashboard-poppins-font-style home-result-card__period">
                                    Per Month
                                  </div>
                                  <div className="car-name-search-bold dashboard-poppins-font-style home-result-card__mileage">
                                    {item?.product_details_car?.mileage?.monthly_mileage ? (
                                      `${item.product_details_car.mileage.monthly_mileage} KM`
                                    ) : (
                                      <div className="car-name-search dashboard-poppins-font-style">
                                        Unlimited mileage
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="row pt-2">
                                <div className="col-md-12 d-flex justify-content-between align-items-center">
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      handleTrackButtonClick("View_Details");
                                      e.preventDefault();
                                      setSelectedProduct(item);
                                      setShowDetailsModal(true);
                                      TagManager.dataLayer({
                                        dataLayer: {
                                          event: "car_detail_view",
                                          page_type: "product_listing",
                                          page_path: window.location.pathname,
                                          page_url: window.location.href,
                                          product_id: item?.product_id,
                                          product_name: item?.product_name,
                                          car_brand: item?.product_details_car?.car_brand,
                                          price_per_day: item?.product_details_car?.price_per_day,
                                        }
                                      });
                                    }}
                                    className="home-result-card__details-link"
                                  >
                                    VIEW DETAILS
                                  </a>
                                  <button
                                    className="book-now-button-style home-result-card__book"
                                    onClick={() => handleBookingClick(item)}
                                  >
                                    BOOK NOW
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="home-results-pagination">
                      <button
                        type="button"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                      >
                        <ChevronLeft size={16} />
                      </button>
                      <span>
                        {currentPage} / {totalPages}
                      </span>
                      <button
                        type="button"
                        disabled={currentPage === totalPages}
                        onClick={() =>
                          setCurrentPage((prev) => Math.min(totalPages, prev + 1))
                        }
                      >
                        <ChevronRight size={16} />
                      </button>
                    </div>
                  </>
                )}
              </main>
            </div>
          </div>

          <section className="landing-services" id="services">
            <h2>OUR SERVICES</h2>
            <div className="landing-services__grid">
              {!isServicesLoading && serviceConfigs.map((service) => {
                const ServiceIcon = ICON_MAP[service.icon] || Tools;

                return (
                  <Link
                    key={service?.slug}
                    to={`/services/${service.slug}`}
                    className="landing-services__card-link"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "auto" });
                      trackEvent({
                        event_name: "Kirkos_Home_Service_Card_Click",
                        event_category: "Navigation",
                        module: "HomePage",
                        payload: { service_slug: service?.slug, service_label: service?.label },
                      }).catch(() => { });
                      if (process.env.REACT_APP_META_PIXEL_ID) {
                        try {
                          ReactPixel.track("ViewContent", {
                            content_type: "service_card",
                            content_name: service?.label,
                            content_category: "OurServices",
                          });
                        } catch (_) { }
                      }
                    }}
                  >
                    <article className="landing-services__card">
                      <ServiceIcon size={34} />
                      <h3>{service?.label}</h3>
                      <p>{service?.title}</p>
                    </article>
                  </Link>
                );
              })}
            </div>
          </section>

          <section className="landing-why">
            <h2>WHY CHOOSE KIRKOS</h2>
            <div className="landing-why__grid">
              <div className="landing-why__card">
                <ShieldCheck size={26} />
                <div>
                  <strong>Reliability in UAE</strong>
                  <span>Trusted by thousands</span>
                </div>
              </div>
              <div className="landing-why__card">
                <Calendar3 size={26} />
                <div>
                  <strong>Ease of Use</strong>
                  <span>Simple booking process</span>
                </div>
              </div>
              <div className="landing-why__card">
                <Clock size={26} />
                <div>
                  <strong>24/7 Support</strong>
                  <span>Always here to help</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>

      <CustomerCustomizeYourSearch
        isOpen={showCreateProduct}
        onClose={() => setShowCreateProduct(false)}
        onCustomizeResult={handleCustomizeResult}
        filterCatalog={filterCatalog}
        totalCars={searchCars}
        initialValues={customizeResult}
      />
      <QuickSearchModal
        isOpen={showAcceptConfirmationModal}
        onClose={() => {
          setShowAcceptConfirmationModal(false);
          setSelectedBookingItem(null);
        }}
        onConfirm={() => {
          setShowAcceptConfirmationModal(false);
          if (selectedBookingItem) {
            const pendingSearchData = {
              pickupPlace: searchMessage ? "Dubai Marina, Dubai, United Arab Emirates" : searchValues.pickup,
              returnPlace: searchMessage ? "Dubai Marina, Dubai, United Arab Emirates" : searchValues.return,
              returnToSameLocation,
              pickupDate: pickupDate ? new Date(pickupDate) : pickupDate,
              dropOffDate: dropOffDate ? new Date(dropOffDate) : dropOffDate,
              selectedTime,
              selectedDropTime,
              pickupLocLatitude: searchMessage ? "25.0786415" : pickupLocation?.latitude?.toString(),
              pickupLocLongitude: searchMessage ? "55.1352524" : pickupLocation?.longitude?.toString(),
              returnLocLatitude: searchMessage ? "25.0786415" : returnLocation?.latitude?.toString(),
              returnLocLongitude: searchMessage ? "55.1352524" : returnLocation?.longitude?.toString(),
              customizeResult, // Include customized search values
            };

            const pendingBooking = {
              selectedItem: selectedBookingItem,
              merchantId: selectedBookingItem.merchant_id,
              searchData: pendingSearchData,
              pickupCharge: selectedBookingItem?.product_car_insurance?.pick_up_charge_outside_40km,
              deliveryCharge: selectedBookingItem?.product_car_insurance?.delivery_charges_outside_40km,
            };

            // Mark this as a one-time homepage-originated pending booking
            sessionStorage.setItem("pendingBookingFromHomepage", "true");
            // Store data in sessionStorage for flows that lose history state (like signup/redirects)
            sessionStorage.setItem("pendingBookingData", JSON.stringify(pendingBooking));

            navigate("/signin", {
              state: {
                pendingBooking: pendingBooking,
              },
            });
          } else {
            navigate("/signin");
          }
        }}
        onRegister={() => {
          setShowAcceptConfirmationModal(false);
          if (selectedBookingItem) {
            // Build the searchData to pass through so after registration/login we go straight to booking
            const pendingSearchData = {
              pickupPlace: searchMessage ? "Dubai Marina, Dubai, United Arab Emirates" : searchValues.pickup,
              returnPlace: searchMessage ? "Dubai Marina, Dubai, United Arab Emirates" : searchValues.return,
              returnToSameLocation,
              pickupDate: pickupDate ? new Date(pickupDate) : pickupDate,
              dropOffDate: dropOffDate ? new Date(dropOffDate) : dropOffDate,
              selectedTime,
              selectedDropTime,
              pickupLocLatitude: searchMessage ? "25.0786415" : pickupLocation?.latitude?.toString(),
              pickupLocLongitude: searchMessage ? "55.1352524" : pickupLocation?.longitude?.toString(),
              returnLocLatitude: searchMessage ? "25.0786415" : returnLocation?.latitude?.toString(),
              returnLocLongitude: searchMessage ? "55.1352524" : returnLocation?.longitude?.toString(),
              customizeResult, // Include customized search values
            };

            const pendingBooking = {
              selectedItem: selectedBookingItem,
              merchantId: selectedBookingItem.merchant_id,
              searchData: pendingSearchData,
              pickupCharge: selectedBookingItem?.product_car_insurance?.pick_up_charge_outside_40km,
              deliveryCharge: selectedBookingItem?.product_car_insurance?.delivery_charges_outside_40km,
            };

            // Mark this as a one-time homepage-originated pending booking
            sessionStorage.setItem("pendingBookingFromHomepage", "true");
            // Also store for multi-page signup redirects
            sessionStorage.setItem("pendingBookingData", JSON.stringify(pendingBooking));

            navigate("/signup", {
              state: {
                pendingBooking: pendingBooking,
              },
            });
          } else {
            navigate("/signup");
          }
          setSelectedBookingItem(null);
        }}
        selectedProduct={selectedBookingItem}
        message={acceptConfirmationMessage}
        locationName={searchValues.pickup}
        startDate={pickupDate}
        endDate={dropOffDate}
      />

      {/* Product Details Modal */}
      <Modal
        show={showDetailsModal}
        onHide={() => setShowDetailsModal(false)}
        size="lg"
        centered
        dialogClassName="home-details-modal-dialog"
        contentClassName="home-details-modal-content"
      >
        <Modal.Header closeButton style={{ padding: "0.75rem 1.25rem", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
          <Modal.Title style={{ fontSize: "1.1rem", fontWeight: "700", color: "#fff" }}>
            {selectedProduct?.product_name?.toUpperCase() || "Product Details"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto", padding: "1.25rem" }}>
          {selectedProduct && (
            <div className="container-fluid">
              <div className="row" style={{ marginBottom: 0 }}>
                {/* Image Section */}
                <div className="col-md-5" style={{ paddingBottom: 0 }}>
                  {selectedProduct?.product_details?.images?.length > 0 ? (
                    <img
                      className="img-fluid rounded"
                      src={selectedProduct?.product_details?.images?.[0]}
                      alt={selectedProduct?.product_name}
                      style={{ width: "100%", maxHeight: "250px", objectFit: "cover" }}
                    />
                  ) : (
                    <img
                      src={noun_no_image}
                      alt="No image"
                      className="img-fluid rounded"
                      style={{ width: "100%", maxHeight: "250px", objectFit: "cover" }}
                    />
                  )}
                  {selectedProduct?.product_details?.images?.length > 1 && (
                    <div className="d-flex flex-wrap gap-2 mt-2">
                      {selectedProduct.product_details.images.slice(1, 5).map((img: string, idx: number) => (
                        <img
                          key={idx}
                          src={img}
                          alt={`Gallery ${idx + 1}`}
                          className="img-thumbnail"
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                        />
                      ))}
                    </div>
                  )}
                </div>

                {/* Details Section */}
                <div className="col-md-7" style={{ paddingBottom: 0 }}>
                  {/* Merchant & Rating */}
                  <div className="mb-3 pb-2 border-bottom">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <div className="fw-bold">{selectedProduct?.shop_name || "N/A"}</div>
                      </div>
                      {selectedProduct?.site_logo && (
                        <div className="text-end">
                          <img
                            src={selectedProduct.site_logo}
                            alt={selectedProduct?.shop_name || "Merchant Logo"}
                            style={{ maxHeight: "36px", maxWidth: "90px", objectFit: "contain" }}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Vehicle Specifications */}
                  <div className="mb-3">
                    <h6 className="mb-1" style={{ fontSize: "0.8rem", fontWeight: "600" }}>Vehicle Specifications</h6>
                    <div className="row g-1" style={{ fontSize: "0.75rem" }}>
                      {selectedProduct?.product_details_car?.car_type && (
                        <div className="col-6">
                          <strong>Type:</strong> {selectedProduct.product_details_car.car_type}
                        </div>
                      )}
                      {selectedProduct?.product_details_car?.model_year && (
                        <div className="col-6">
                          <strong>Year:</strong> {selectedProduct.product_details_car.model_year}
                        </div>
                      )}
                      {selectedProduct?.product_details_car?.transmission && (
                        <div className="col-6">
                          <strong>Transmission:</strong> {selectedProduct.product_details_car.transmission}
                        </div>
                      )}
                      {selectedProduct?.product_details_car?.fuel_type && (
                        <div className="col-6">
                          <strong>Fuel:</strong> {selectedProduct.product_details_car.fuel_type}
                        </div>
                      )}
                      {selectedProduct?.product_details_car?.number_of_seats && (
                        <div className="col-6">
                          <strong>Seats:</strong> {selectedProduct.product_details_car.number_of_seats}
                        </div>
                      )}
                      {selectedProduct?.product_details_car?.number_of_doors && (
                        <div className="col-6">
                          <strong>Doors:</strong> {selectedProduct.product_details_car.number_of_doors}
                        </div>
                      )}
                      {selectedProduct?.product_details_car?.car_color && (
                        <div className="col-6">
                          <strong>Color:</strong> {selectedProduct.product_details_car.car_color}
                        </div>
                      )}
                      {selectedProduct?.product_details_car?.sipp && (
                        <div className="col-6">
                          <strong>SIPP Code:</strong> {selectedProduct.product_details_car.sipp}
                        </div>
                      )}
                      {selectedProduct?.product_details_car?.engine_type && (
                        <div className="col-6">
                          <strong>Engine:</strong> {selectedProduct.product_details_car.engine_type}
                        </div>
                      )}
                      {selectedProduct?.product_details_car?.max_power && (
                        <div className="col-6">
                          <strong>Power:</strong> {selectedProduct.product_details_car.max_power}
                        </div>
                      )}
                      {selectedProduct?.product_details_car?.deposit > 0 && (
                        <div className="col-6">
                          <strong>Deposit:</strong> AED {selectedProduct.product_details_car.deposit}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Features and Description Row */}
              <div className="row" style={{ marginTop: 0, marginBottom: 0 }}>
                <div className="col-md-6">

                  {/* Description */}
                  {selectedProduct?.product_details_car?.description && (
                    <div className="mb-3">
                      <h6 className="mb-1" style={{ fontSize: "0.8rem", fontWeight: "600" }}>Description</h6>
                      <p style={{ fontSize: "0.75rem", marginBottom: 0 }}>
                        {selectedProduct.product_details_car.description}
                      </p>
                    </div>
                  )}
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <h6 className="mb-1" style={{ fontSize: "0.8rem", fontWeight: "600" }}>Features</h6>
                    <div className="d-flex flex-wrap gap-1" style={{ fontSize: "0.72rem" }}>
                      {selectedProduct?.product_details_car?.ac && (
                        <span className="badge bg-light text-dark border">AC</span>
                      )}
                      {selectedProduct?.product_details_car?.cruise_control && (
                        <span className="badge bg-light text-dark border">Cruise Control</span>
                      )}
                      {selectedProduct?.product_details_car?.key_less_entry && (
                        <span className="badge bg-light text-dark border">Keyless Entry</span>
                      )}
                      {selectedProduct?.product_details_car?.abs_break && (
                        <span className="badge bg-light text-dark border">ABS</span>
                      )}
                      {selectedProduct?.product_details_car?.buletooth && (
                        <span className="badge bg-light text-dark border">Bluetooth</span>
                      )}
                      {selectedProduct?.product_details_car?.duel_front_air_bag && (
                        <span className="badge bg-light text-dark border">Dual Airbags</span>
                      )}
                    </div>
                  </div>
                </div>

              </div>

              {/* Pricing Section */}
              <div
                className="row"
                style={{
                  backgroundColor: "#000",
                  marginLeft: "-12px",
                  marginRight: "-12px",
                  paddingLeft: "12px",
                  paddingRight: "12px",
                  paddingTop: "1rem",
                  paddingBottom: "1rem",
                  marginTop: 0,
                }}
              >
                <div className="col-12 mb-2">
                  <h6 style={{ fontSize: "0.8rem", fontWeight: "600", color: "#fff", marginBottom: 0 }}>
                    Pricing & Mileage
                  </h6>
                </div>
                <div className="col-md-4 mb-2">
                  <div className="card border" style={{ fontSize: "0.85rem", backgroundColor: "#000", borderColor: "#333" }}>
                    <div className="text-center" style={{ padding: "0.5rem" }}>
                      <div className="fw-bold" style={{ color: "#fff" }}>Per Day</div>
                      <div className="fw-bold" style={{ fontSize: "1.1rem", color: "#F0B64F" }}>
                        AED {selectedProduct?.product_details_car?.price_per_day || "0"}
                      </div>
                      <small style={{ color: "#aaa" }}>
                        {selectedProduct?.product_car_insurance?.mileage_model?.daily_mileage
                          ? `${selectedProduct.product_car_insurance.mileage_model.daily_mileage} KM/day`
                          : "Unlimited mileage"}
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-2">
                  <div className="card border" style={{ fontSize: "0.85rem", backgroundColor: "#000", borderColor: "#333" }}>
                    <div className="text-center" style={{ padding: "0.5rem" }}>
                      <div className="fw-bold" style={{ color: "#fff" }}>Per Week</div>
                      <div className="fw-bold" style={{ fontSize: "1.1rem", color: "#F0B64F" }}>
                        AED {selectedProduct?.product_details_car?.price_per_week || "0"}
                      </div>
                      <small style={{ color: "#aaa" }}>
                        {selectedProduct?.product_car_insurance?.mileage_model?.weekly_mileage
                          ? `${selectedProduct.product_car_insurance.mileage_model.weekly_mileage} KM/week`
                          : "Unlimited mileage"}
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-2">
                  <div className="card border" style={{ fontSize: "0.85rem", backgroundColor: "#000", borderColor: "#333" }}>
                    <div className="text-center" style={{ padding: "0.5rem" }}>
                      <div className="fw-bold" style={{ color: "#fff" }}>Per Month</div>
                      <div className="fw-bold" style={{ fontSize: "1.1rem", color: "#F0B64F" }}>
                        AED {selectedProduct?.product_details_car?.price_per_month || "0"}
                      </div>
                      <small style={{ color: "#aaa" }}>
                        {selectedProduct?.product_car_insurance?.mileage_model?.monthly_mileage
                          ? `${selectedProduct.product_car_insurance.mileage_model.monthly_mileage} KM/month`
                          : "Unlimited mileage"}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={{ padding: "0.4rem 0.75rem" }}>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => {
              handleTrackButtonClick("Close_View_Details");
              setShowDetailsModal(false);
            }}
          >
            Close
          </button>
          <button
            className="book-now-button-style"
            onClick={() => {
              if (selectedProduct) {
                handleTrackButtonClick("Close_View_Details");
                setShowDetailsModal(false);
                handleBookingClick(selectedProduct);
              }
            }}
          >
            BOOK NOW
          </button>
        </Modal.Footer>
      </Modal>
      <LocationPickerModal
        isOpen={showPickupMapModal}
        onClose={() => setShowPickupMapModal(false)}
        onLocationSelect={handlePickupMapSelect}
        initialLocation={
          pickupLocation.latitude !== null && pickupLocation.longitude !== null
            ? { latitude: pickupLocation.latitude as number, longitude: pickupLocation.longitude as number }
            : { latitude: 25.1972, longitude: 55.2744 }
        }
        initialAddress={searchValues.pickup}
        title="Select Pick Up Location"
      />
      <LocationPickerModal
        isOpen={showReturnMapModal}
        onClose={() => setShowReturnMapModal(false)}
        onLocationSelect={handleReturnMapSelect}
        initialLocation={
          returnLocation.latitude !== null && returnLocation.longitude !== null
            ? { latitude: returnLocation.latitude as number, longitude: returnLocation.longitude as number }
            : pickupLocation.latitude !== null && pickupLocation.longitude !== null
              ? { latitude: pickupLocation.latitude as number, longitude: pickupLocation.longitude as number }
              : { latitude: 25.1972, longitude: 55.2744 }
        }
        initialAddress={searchValues.return}
        title="Select Return Location"
        disableAutoSelectOnMount={!searchValues.return}
      />
      <DraggableWhatsAppIcon />
    </>
  );
};

export default HomePage;
